import Vue from 'vue'
import Router from 'vue-router'

// pages
import Main from '@/components/Main'
import RelationalDatabaseServiceMonitor from '@/components/monitor/rds/RelationalDatabaseServiceMonitor'
import RelationalDatabaseServiceDetail from '@/components/monitor/rds/RelationalDatabaseServiceDetail'
import RelationalDatabaseServiceWarning from '@/components/monitor/rds/RelationalDatabaseServiceWarning'
import RDS from '@/components/monitor/rds/rds_dashboard/RDS'
import ElasticResourceAli from "@/components/monitor/eip/ElasticResourceAli"
import ElasticResourceDetailAli from "@/components/monitor/eip/ElasticResourceDetailAli"
import InstanceAli from '@/components/monitor/eip/eip_dashboard/InstanceAli'
import ElasticResourceAliWarning from '@/components/monitor/eip/ElasticResourceAliWarning'
import TableElasticResourceAliWarning from "@/components/monitor/eip/TableElasticResourceAliWarning"
import BillingMonitor from '@/components/monitor/billing/BillingMonitor'
import AlarmContact from '@/components/alarm_contact/AlarmContact'
import ServerSearchs from '@/components/timer_switchs/server_searchs/ServerSearchs'
import InstanceList from '@/components/instance_lists/instance_list/InstanceList'
import Case from '@/components/cases/case/Case'
import CaseDetail from '@/components/cases/case/CaseDetail'
import MessageQueueMonitor from '@/components/monitor/mq/MessageQueueMonitor'
import MessageQueueDetail from '@/components/monitor/mq/MessageQueueDetail'
import MessageQueue from '@/components/monitor/mq/message_queue_dashboard/MessageQueue'
import BillingPage from '@/components/ebilling/billing_page/BillingPage'
import RIPage from '@/components/ebilling/ri_page/RIPage'
import DashboardHome from '@/components/dashboardHome/DashboardHome'
import ObjectStorageMonitor from '@/components/monitor/object_storage/ObjectStorageMonitor'
import ObjectStorageDetail from '@/components/monitor/object_storage/ObjectStorageDetail'
import ObjectStorage from '@/components/monitor/object_storage/object_storage_dashboard/ObjectStorage'
import LogManagementMonitor from '@/components/monitor/log_management/LogManagementMonitor'
import LogManagementDetail from '@/components/monitor/log_management/LogManagementDetail'
import LogManagement from '@/components/monitor/log_management/log_management_dashboard/LogManagement'
import CenMonitor from '@/components/monitor/network/cen/CenMonitor'
import CenDetail from '@/components/monitor/network/cen/CenDetail'
import CEN from '@/components/monitor/network/cen/cen_dashboard/CEN'
import SlBillingPage from '@/components/ebilling/sl_billing_page/SlBillingPage'
import RuleEngine from '@/components/rule_engine/RuleEngine'
import PatchMonitor from '@/components/patch_management/patch_monitor/PatchMonitor'
import Policies from '@/components/patch_management/policy/Policies'
import PatchBaselineConfiguration from '@/components/patch_management/policy/patch_baseline_configuration/PatchBaselineConfiguration'
import PatchCommandParameters from '@/components/patch_management/patch_command_parameters/PatchCommandParameters'
import CommandDetail from '@/components/patch_management/patch_command_parameters/CommandDetail'
import AddOrUpdateRunCommands from '@/components/patch_management/policy/AddOrUpdateRunCommands'
import CommandHistoryDetail from '@/components/patch_management/patch_command_parameters/CommandHistoryDetail'
import LogMonitor from '@/components/monitor/logs/log/LogMonitor'
import Security from '@/components/monitor/logs/security/Security'
import ThirdMainLogs from '@/components/monitor/logs/ThirdMainLogs'
import ResourceGroup from '@/components/monitor/ResourceGroup/ResourceGroup'
import addOrUpdateResourceGroup from '@/components/monitor/ResourceGroup/AddOrUpdateResourceGroup'
import ThirdMainResource from '@/components/monitor/ResourceGroup/ThirdMainResource'
import ElasticComputeCloudWarning from '@/components/monitor/ec2/ElasticComputeCloudWarning'
import ElasticComputeCloudMonitor from '@/components/monitor/ec2/ElasticComputeCloudMonitor'
import ElasticComputeCloudDetail from '@/components/monitor/ec2/ElasticComputeCloudDetail'
import Instance from '@/components/monitor/ec2/instance_dashboard/Instance'
import ElasticBlockStoreMonitor from '@/components/monitor/ebs/ElasticBlockStoreMonitor'
import ElasticBlockStoreWarning from '@/components/monitor/ebs/ElasticBlockStoreWarning'
import ElasticBlockStoreDetail from '@/components/monitor/ebs/ElasticBlockStoreDetail'
import EBS from '@/components/monitor/ebs/ebs_dashboard/EBS'
import SystemTask from '@/components/configuration/configuration_management/system_task/SystemTask'
import AutoscalingMonitor from '@/components/monitor/autoscaling/AutoscalingMonitor'
import AutoscalingDetail from '@/components/monitor/autoscaling/AutoscalingDetail'
import InstanceAutoscaling from '@/components/monitor/autoscaling/instance_dashboard/InstanceAutoscaling'
import WebApplicationFirewallMonitor from '@/components/monitor/webApplicationFirewall/WebApplicationFirewallMonitor'
import WebApplicationFirewallDetail from '@/components/monitor/webApplicationFirewall/WebApplicationFirewallDetail'
import InstanceWebApplicationFirewall from '@/components/monitor/webApplicationFirewall/instance_dashboard/InstanceWebApplicationFirewall'
import BackPlanMonitor from '@/components/monitor/backPlan/BackPlanMonitor'
import BackPlanDetail from '@/components/monitor/backPlan/BackPlanDetail'
import BackPlanWarning from '@/components/monitor/backPlan/BackPlanWarning'
import DefaultAlarmConfiguration from '@/components/configuration/configuration_management/default_alarm_configuration/DefaultAlarmConfiguration'
import Schedules from '@/components/configuration/configuration_management/schedules/Schedules'
import CustomerDefinedAlarmConfiguration from '@/components/configuration/configuration_management/customer_defined_alarm_configuration/CustomerDefinedAlarmConfiguration'
import AlertRuleLists from '@/components/configuration/configuration_management/customer_defined_alarm_configuration/AlertRuleLists'
import Fourth from '@/components/configuration/configuration_management/Fourth'
import Fifth from '@/components/configuration/permissions_configuration_management/Fifth'
import Accounts from '@/components/configuration/permissions_configuration_management/account/Accounts'
import Permissions from '@/components/configuration/permissions_configuration_management/permission/Permissions'
import Users from '@/components/configuration/permissions_configuration_management/user/Users'
import RoleManagement from '@/components/configuration/permissions_configuration_management/role_management/RoleManagement'
import AddOrUpdateRoleManagement from '@/components/configuration/permissions_configuration_management/role_management/AddOrUpdateRoleManagement'
import Groups from '@/components/configuration/permissions_configuration_management/group/Groups'
import ResourcePermission from '@/components/configuration/permissions_configuration_management/resource_permission/ResourcePermission'
import AccountGroup from '@/components/configuration/permissions_configuration_management/account_group/AccountGroup'
import AccountGroupConfig from '@/components/configuration/permissions_configuration_management/account_group/AccountGroupConfig'
import ApprovalTask from '@/components/approval_task/ApprovalTask'
import ApprovalTaskDetail from '@/components/approval_task/approval_task/ApprovalTaskDetail'
import SlbMonitor from '@/components/monitor/network/slb/SlbMonitor'
import SlbDetail from '@/components/monitor/network/slb/SlbDetail'
import SLB from '@/components/monitor/network/slb/slb_dashboard/SLB'
import SlbWarning from '@/components/monitor/network/slb/SlbWarning'
import NatMonitor from '@/components/monitor/network/nat/NatMonitor'
import NatDetail from '@/components/monitor/network/nat/NatDetail'
import InstanceNat from '@/components/monitor/network/nat/instance_dashboard/InstanceNat'
import Satisfaction from '@/components/cases/satisfaction/Satisfaction'
import ElasticBlockStoreResource from '@/components/configuration/resource_configuration_management/aws/ebs/ElasticBlockStoreResource'
import ElasticComputeCloudResource from '@/components/configuration/resource_configuration_management/aws/ec2/ElasticComputeCloudResource'
import DedicatedHostingResource from '@/components/configuration/resource_configuration_management/aws/bsh/DedicatedHostingResource'
import ElasticLoadBalancingResource from '@/components/configuration/resource_configuration_management/aws/elb/ElasticLoadBalancingResource'
import RelationalDatabaseServiceResource from '@/components/configuration/resource_configuration_management/aws/rds/RelationalDatabaseServiceResource'
import RedshiftResource from '@/components/configuration/resource_configuration_management/aws/redshift/RedshiftResource'
import SimpleStorageServiceResource from '@/components/configuration/resource_configuration_management/aws/s3/SimpleStorageServiceResource'
import VirtualPrivateCloudResource from '@/components/configuration/resource_configuration_management/aws/vpc/VirtualPrivateCloudResource'
import ElasticResource from '@/components/configuration/resource_configuration_management/aws/eip/ElasticResource'
import GatewayResource from '@/components/configuration/resource_configuration_management/aws/gateway/GatewayResource'
import RouteResource from '@/components/configuration/resource_configuration_management/aws/route/RouteResource'
import SubnetResource from '@/components/configuration/resource_configuration_management/aws/subnet/SubnetResource'
import ElasticBlockStoreResourceAzure from '@/components/configuration/resource_configuration_management/azure/ebs/ElasticBlockStoreResourceAzure'
import ElasticComputeCloudResourceAzure from '@/components/configuration/resource_configuration_management/azure/ec2/ElasticComputeCloudResourceAzure'
import RelationalDatabaseServiceResourceAzure from '@/components/configuration/resource_configuration_management/azure/rds/RelationalDatabaseServiceResourceAzure'
import SimpleStorageServiceResourceAzure from '@/components/configuration/resource_configuration_management/azure/s3/SimpleStorageServiceResourceAzure'
import VirtualPrivateCloudResourceAzure from '@/components/configuration/resource_configuration_management/azure/vpc/VirtualPrivateCloudResourceAzure'
import Sixth from '@/components/configuration/resource_configuration_management/aws/Sixth'
import Seventh from '@/components/configuration/resource_configuration_management/azure/Seventh'
import Twelfth from '@/components/configuration/resource_configuration_management/ali/Twelfth'
import Fourteenth from '@/components/configuration/resource_configuration_management/gcp/Fourteenth'
import Fifteenth from '@/components/configuration/resource_configuration_management/hwc/Fifteenth'
import ElasticComputeCloudResourceHwc from '@/components/configuration/resource_configuration_management/hwc/ecs/ElasticComputeCloudResourceHwc'
import RelationalDatabaseServiceResourceHwc from '@/components/configuration/resource_configuration_management/hwc/rds/RelationalDatabaseServiceResourceHwc'
import ElasticCloudDiskHwc from '@/components/configuration/resource_configuration_management/hwc/evs/ElasticCloudDiskHwc'
import ObjectStorageHwc from '@/components/configuration/resource_configuration_management/hwc/obs/ObjectStorageHwc'
import KeyPerformanceIndication from '@/components/cases/key_performance_indication/KeyPerformanceIndication'
import SecurityLogConfiguration from '@/components/configuration/configuration_management/security_log_configuration/SecurityLogConfiguration'
import AgwMonitor from '@/components/monitor/network/agw/AgwMonitor'
import AgwWarning from '@/components/monitor/network/agw/AgwWarning'
import AgwDetail from '@/components/monitor/network/agw/AgwDetail'
import AGW from '@/components/monitor/network/agw/agw_dashboard/AGW'
import ThirdMainAIMonitor from "@/components/ai_monitor/thirdMainAIMonitor"
import AIDashboard from '@/components/ai_monitor/ai_dashboard/AIDashboard'
import InstanceDetail from '@/components/ai_monitor/ai_dashboard/InstanceDetail'
import DatabaseDetail from '@/components/ai_monitor/ai_dashboard/DatabaseDetail'
import OperatingSystem from '@/components/ai_monitor/operating_system/OperatingSystem'
import ApplicationConfiguration from '@/components/ai_monitor/application_configuration/ApplicationConfiguration'
import ApplicationSystemAlarm from '@/components/ai_monitor/application_system_alarm/ApplicationSystemAlarm'
import SecurityGroup from '@/components/configuration/resource_configuration_management/aws/security_group/SecurityGroup'
import WebMonitor from '@/components/monitor/network/web/WebMonitor'
import WebWarning from '@/components/monitor/network/web/WebWarning'
import WebDetail from '@/components/monitor/network/web/WebDetail'
import WEB from '@/components/monitor/network/web/web_dashboard/WEB'
import CompanyManagement from '@/components/configuration/permissions_configuration_management/company_management/CompanyManagement'
import RedshiftMonitor from '@/components/monitor/redshift/RedshiftMonitor'
import RedshiftWarning from '@/components/monitor/redshift/RedshiftWarning'
import RedshiftDetail from '@/components/monitor/redshift/RedshiftDetail'
import Redshift from '@/components/monitor/redshift/redshift_dashboard/Redshift'
import StorageGatewayMonitor from '@/components/monitor/storage_gateway/StorageGatewayMonitor'
import StorageGatewayWarning from '@/components/monitor/storage_gateway/StorageGatewayWarning'
import StorageGatewayDetail from '@/components/monitor/storage_gateway/StorageGatewayDetail'
import StorageGateway from '@/components/monitor/storage_gateway/storagegateway_dashboard/StorageGateway'
import ElasticsearchMonitor from '@/components/monitor/es/ElasticsearchMonitor'
import ElasticsearchWarning from '@/components/monitor/es/ElasticsearchWarning'
import ElasticsearchDetail from '@/components/monitor/es/ElasticsearchDetail'
import Elasticsearch from '@/components/monitor/es/elasticsearch_dashboard/Elasticsearch'
import OperationDutyManagement from '@/components/configuration/operation_kpi_configuration_management/operation_duty_management/OperationDutyManagement'
import OvertimeManagement from '@/components/configuration/operation_kpi_configuration_management/overtime_management/OvertimeManagement'
import Eighth from '@/components/configuration/operation_kpi_configuration_management/Eighth'
import ApprovalFlowConfiguration from '@/components/configuration/approval_flow_configuration/approval_flow/ApprovalFlowConfiguration'
import Node from '@/components/configuration/approval_flow_configuration/node/Node'
import Ninth from '@/components/configuration/approval_flow_configuration/Ninth'
import OperationReport from '@/components/configuration/operation_kpi_configuration_management/operation_report/OperationReport'
import ReportConfiguration from '@/components/configuration/operation_kpi_configuration_management/operation_report/report_configuration/ReportConfiguration'
import CloudTrail from '@/components/monitor/logs/cloudTrail/CloudTrail'
import Tenth from '@/components/configuration/resource_configuration_management/aws/reserved_instance/Tenth'
import ElasticComputeCloudReservedInstance from '@/components/configuration/resource_configuration_management/aws/reserved_instance/ec2/ElasticComputeCloudResource'
import RelationalDatabaseServiceReservedInstance from '@/components/configuration/resource_configuration_management/aws/reserved_instance/rds/RelationalDatabaseServiceResource'
import ElasticacheReservedInstance from '@/components/configuration/resource_configuration_management/aws/reserved_instance/elasticache/ElasticacheResource'
import RedshiftReservedInstance from '@/components/configuration/resource_configuration_management/aws/reserved_instance/redshift/RedshiftResource'
import ElasticsearchReservedInstance from '@/components/configuration/resource_configuration_management/aws/reserved_instance/elasticsearch/ElasticsearchResource'
import ElasticComputeCloudResourceAli from '@/components/configuration/resource_configuration_management/ali/ecs/ElasticComputeCloudResourceAli'
import RelationalDatabaseServiceResourceAli from '@/components/configuration/resource_configuration_management/ali/rds/RelationalDatabaseServiceResourceAli'
import ElasticBlockStoreResourceAli from '@/components/configuration/resource_configuration_management/ali/ebs/ElasticBlockStoreResourceAli'
import ElasticResourceIp from '@/components/configuration/resource_configuration_management/ali/eip/ElasticResourceIp'
import ElasticLoadBalancingResourceAli from '@/components/configuration/resource_configuration_management/ali/elb/ElasticLoadBalancingResourceAli'
import RedisAli from '@/components/configuration/resource_configuration_management/ali/redis/Redis'
import AckAli from '@/components/configuration/resource_configuration_management/ali/ack/Ack'
import ElasticComputeCloudResourceGcp from '@/components/configuration/resource_configuration_management/gcp/ecs/ElasticComputeCloudResourceGcp'
import RelationalDatabaseServiceResourceGcp from '@/components/configuration/resource_configuration_management/gcp/rds/RelationalDatabaseServiceResourceGcp'
import ElasticBlockStoreResourceGcp from '@/components/configuration/resource_configuration_management/gcp/ebs/ElasticBlockStoreResourceGcp'
import ElasticLoadBalancingResourceGcp from '@/components/configuration/resource_configuration_management/gcp/elb/ElasticLoadBalancingResourceGcp'
import CloudStorageGcp from '@/components/configuration/resource_configuration_management/gcp/cloudStorage/CloudStorageGcp'
import BigQuery from '@/components/configuration/resource_configuration_management/gcp/bigQuery/BigQuery'
import RedisGcp from '@/components/configuration/resource_configuration_management/gcp/redis/Redis'
import Filestore from '@/components/configuration/resource_configuration_management/gcp/filestore/Filestore'
import Kubernetes from '@/components/configuration/resource_configuration_management/gcp/kubernetes/Kubernetes'
import GcpLogging from '@/components/configuration/resource_configuration_management/gcp/cloudLogging/CloudLogging'
import Logrouting from '@/components/configuration/resource_configuration_management/gcp/cloudLogging/log/Logrouting'
import Loggingstored from '@/components/configuration/resource_configuration_management/gcp/cloudLogging/log/Loggingstored'
import VPC from '@/components/configuration/resource_configuration_management/ali/vpc/Vpc'
import OSS from '@/components/configuration/resource_configuration_management/ali/oss/Oss'
import NatGateway from '@/components/configuration/resource_configuration_management/ali/natGateway/NatGateway'
import SLS from '@/components/configuration/resource_configuration_management/ali/sls/Sls'
import AutoScaling from '@/components/configuration/resource_configuration_management/ali/autoScaling/AutoScaling'
import ClickHouse from '@/components/configuration/resource_configuration_management/ali/clickHouse/ClickHouse'
import CENAli from '@/components/configuration/resource_configuration_management/ali/cen/Cen'
import Kafka from '@/components/configuration/resource_configuration_management/ali/kafka/Kafka'
import ReservedInstances from '@/components/configuration/resource_configuration_management/ali/reservedInstances/ReservedInstances'
import Waf from '@/components/configuration/resource_configuration_management/ali/waf/Waf'
import MenuManagement from '@/components/configuration/permissions_configuration_management/menu_management/MenuManagement'
import TrustAdvisor from '@/components/monitor/trustAdvisor/TrustAdvisor'
import TrustAdvisorDetail from '@/components/monitor/trustAdvisor/trustAdvisor_list/TrustAdvisorDetail'
import AffectedResourcesDetail from '@/components/monitor/trustAdvisor/trustAdvisor_list/AffectedResourcesDetail'
import MonitorMailbox from '@/components/configuration/configuration_management/monitor_mailbox_configuration/Mailboxs'
import ContactConfiguration from '@/components/alarm_contact/alarm_contact_group/contact_configuration/ContactConfiguration'
import LabelSynchronization from '@/components/configuration/label_management/label_synchronization/LabelSynchronization'
import Tag from '@/components/configuration/label_management/tag_management/Tag'
import TagMonitoring from '@/components/configuration/label_management/tag_monitoring/TagMonitoring'
import CostCalculation from '@/components/ebilling/cost_calculation/CostCalculation'
import ResourceApplication from '@/components/resource_lifecycle_management/resource_application/ResourceApplication'
import ResourceChange from '@/components/resource_lifecycle_management/resource_change/ResourceChange'
import ResourceRecycle from '@/components/resource_lifecycle_management/resource_recycle/ResourceRecycle'
import ResourceDetail from '@/components/resource_lifecycle_management/resource_service_directory/ResourceServiceDirectoryDetail'
import ResourceRenewal from '@/components/resource_lifecycle_management/resource_renewal/ResourceRenewal'
import AmazonVirtualMachineDetail from '@/components/resource_lifecycle_management/resource_application/aws/virtual_machine/AmazonVirtualMachineDetail'
import AmazonVirtualNetworkDetail from '@/components/resource_lifecycle_management/resource_application/aws/virtual_network/AmazonVirtualNetworkDetail'
import AmazonObjectStorageDetail from '@/components/resource_lifecycle_management/resource_application/aws/object_storage/AmazonObjectStorageDetail'
import AmazonManagedDatabaseDetail from '@/components/resource_lifecycle_management/resource_application/aws/managed_database/AmazonManagedDatabaseDetail'
import AmazonElasticAddressDetail from '@/components/resource_lifecycle_management/resource_application/aws/elastic_ip/AmazonElasticAddressDetail'
import ResourceServiceDirectory from '@/components/resource_lifecycle_management/resource_service_directory/ResourceServiceDirectory'
import ResourceServiceOperationReport from '@/components/resource_lifecycle_management/resource_service_operation_report/ResourceServiceOperationReport'
import AzureVirtualMachineDetail from '@/components/resource_lifecycle_management/resource_application/azure/virtual_machine/AzureVirtualMachineDetail'
import AzureVirtualNetworkDetail from '@/components/resource_lifecycle_management/resource_application/azure/virtual_network/AzureVirtualNetworkDetail'
import AzureObjectStorageDetail from '@/components/resource_lifecycle_management/resource_application/azure/object_storage/AzureObjectStorageDetail'
import AzureManagedDatabaseDetail from '@/components/resource_lifecycle_management/resource_application/azure/managed_database/AzureManagedDatabaseDetail'
import AzureElasticAddressDetail from '@/components/resource_lifecycle_management/resource_application/azure/elastic_ip/AzureElasticAddressDetail'
import DealwithDetail from '@/components/approval_task/approval_task/DealwithDetail'
import AppServiceResourceAzure from '@/components/configuration/resource_configuration_management/azure/app_service/AppServiceResourceAzure'
import AWS from '@/components/ebilling/ebilling/AWS'
import Azure from '@/components/ebilling/ebilling/Azure'
import ExceptionResource from '@/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/ExceptionResource'
import ComplianceChecks from '@/components/monitor/compliance_checks/ComplianceChecks'
import ComplianceChecksDetail from '@/components/monitor/compliance_checks/complianceChecks_list/ComplianceChecksDetail'
import CloudUserMonitor from '@/components/monitor/cloud_user/CloudUserMonitor'
import CloudUserWarning from '@/components/monitor/cloud_user/CloudUserWarning'
import CloudUserDetail from '@/components/monitor/cloud_user/CloudUserDetail'
import PerformanceInsights from "@/components/monitor/pf/PerformanceInsights"
import LoadBalancingResourceAzure from '@/components/configuration/resource_configuration_management/azure/loadbalance/LoadBalancingResourceAzure'
import Event from '@/components/configuration/resource_configuration_management/aws/event/EventResource'
import GroupResource from '@/components/configuration/resource_configuration_management/aws/iam_config/group/GroupResource'
import PolicyResource from '@/components/configuration/resource_configuration_management/aws/iam_config/policy/PolicyResource'
import AkskResource from '@/components/configuration/resource_configuration_management/aws/iam_config/aksk/AkskResource'
import Eleventh from '@/components/configuration/resource_configuration_management/aws/iam_config/Eleventh'
import ElasticsearchResource from '@/components/configuration/resource_configuration_management/aws/elasticsearch/ElasticsearchResource'
import IdentityAndAccessManagementResource from '@/components/configuration/resource_configuration_management/aws/iam_config/iam/IdentityAndAccessManagementResource'
import ReservedInstancePurchase from '@/components/configuration/configuration_management/reserved_instance_purchase/ReservedInstancePurchase'
import WeeklyReport from '@/components/monitor/weeklyReport/WeeklyReport'
import ElastiCacheResourceInfo from '@/components/configuration/resource_configuration_management/aws/elasticache/ElastiCacheResourceInfo'
import ElastiCacheResourceMemcached from '@/components/configuration/resource_configuration_management/aws/elasticache/memcached/ElastiCacheResourceMemcached'
import ElastiCacheResourceRedis from '@/components/configuration/resource_configuration_management/aws/elasticache/redis/ElastiCacheResourceRedis'
import BackupInfo from '@/components/configuration/resource_configuration_management/aws/backup/BackupInfo'
import BackupRepository from '@/components/configuration/resource_configuration_management/aws/backup/repository/BackupRepository'
import BackupVaultName from '@/components/configuration/resource_configuration_management/aws/backup/repository/BackupVaultName'
import BackupPlan from '@/components/configuration/resource_configuration_management/aws/backup/plan/BackupPlan'
import BackupPlanName from '@/components/configuration/resource_configuration_management/aws/backup/plan/BackupPlanName'
import Mailbox from '@/components/monitor/non_cloud_resources/mailbox/Mailbox'
import WebsiteHealthStatus from '@/components/monitor/non_cloud_resources/website_health_status/WebsiteHealthStatus'
import ThirdMainWebsiteHealthStatus from '@/components/monitor/non_cloud_resources/ThirdMainWebsiteHealthStatus'
import RedisMonitor from '@/components/monitor/elasticache/redis/RedisMonitor'
import RedisWarning from '@/components/monitor/elasticache/redis/RedisWarning'
import RedisDetail from '@/components/monitor/elasticache/redis/RedisDetail'
import Redis from '@/components/monitor/elasticache/redis/redis_dashboard/Redis'
import ThirdMainRedis from '@/components/monitor/elasticache/ThirdMainRedis'
import CostAllocation from '@/components/ebilling/cost_allocation/CostAllocation'
import AddOrUpdateCostAllocation from '@/components/ebilling/cost_allocation/AddOrUpdateCostAllocation'
import ResourceOptimization from '@/components/ebilling/resource_optimization/ResourceOptimization'
import Thirteenth from '@/components/ebilling/reserved_instance/Thirteenth'
import UtilizationReport from '@/components/ebilling/reserved_instance/utilization_report/UtilizationReport'
import CoverageReport from '@/components/ebilling/reserved_instance/coverage_report/CoverageReport'
import ElasticBlockStoreSnapshotResource from '@/components/configuration/resource_configuration_management/aws/ebs_snapshot/ElasticBlockStoreSnapshotResource'
import NatGatewayResource from '@/components/configuration/resource_configuration_management/aws/nat_gateway/NatGatewayResource'
import EKS from '@/components/configuration/resource_configuration_management/aws/eks/EKS'
import EMR from '@/components/configuration/resource_configuration_management/aws/emr/EMR'
import TGW from '@/components/configuration/resource_configuration_management/aws/tgw/TGW'
import DynamoDB from '@/components/configuration/resource_configuration_management/aws/dynamoDB/DynamoDB'
import ECR from '@/components/configuration/resource_configuration_management/aws/ecr/ECR'
import ECS from '@/components/configuration/resource_configuration_management/aws/ecs/ECS'
import ClusterDescription from '@/components/configuration/resource_configuration_management/aws/ecs/clusterDescription'
import KMS from '@/components/configuration/resource_configuration_management/aws/kms/KMS'
import DMS from '@/components/configuration/resource_configuration_management/aws/dms/DmsInfo'
import ServerlessReplications from '@/components/configuration/resource_configuration_management/aws/dms/serverlessReplications/serverlessReplications'
import ReplicationInstances from '@/components/configuration/resource_configuration_management/aws/dms/replicationInstances/replicationInstances'
/**************change**********************/
import DiscountConfiguration from '@/components/ebilling/gcp/discount_configuration/DiscountConfiguration'
import CudRecommendationPage from '@/components/ebilling/gcp/cud_recommendation_page/CudRecommendationPage'

// login
// import Login from '@/components/configuration/permissions_configuration_management/user/Login'
// register
import Register from '@/components/configuration/permissions_configuration_management/user/Register'
// forgetPassword
import ForgetPassword from '@/components/configuration/permissions_configuration_management/user/ForgetPassword'
// changePassword
import ChangePassword from '@/components/configuration/permissions_configuration_management/user/ChangePassword'
// 三级菜单
import ThirdMain from '@/components/monitor/network/ThirdMain'

//  实例 新增 查看预测监控概况 界面
import InstanceForecast from '@/components/monitor/ec2/instance_dashboard/InstanceForecast'

// 磁盘 新增 查看预测监控概况 界面
import EBSForecast from '@/components/monitor/ebs/ebs_dashboard/EBSForecast'

// 数据库 新增 查看预测监控概况 界面
import RDSForecast from '@/components/monitor/rds/rds_dashboard/RDSForecast'

// 选择版本界面
import SelectVersion from '../components/configuration/permissions_configuration_management/user/SelectVersion'

// 操作手册界面
import PageManual from '../components/configuration/permissions_configuration_management/user/PageManual'

// // DocDB监控项
import DocDBMonitor from '@/components/monitor/DocDBMonitor/RedisMonitor'

import DocDBDetail from '@/components/monitor/DocDBMonitor/RedisDetail'

import DocDBWarning from '@/components/monitor/DocDBMonitor/RedisWarning'

// DocDB
import DocDB from '@/components/monitor/DocDBMonitor/redis_dashboard/Redis'

// DocDBManage 配置
import DocDBManage from '@/components/monitor/DocDBMonitor/DocDBManage'

//  OriginalBillEntry sme账单
import OriginalBillEntry from '@/components/ebilling/OriginalBillEntry/aws/OriginalBillEntry'

// 账单规则

import BillingRules from '@/components/ebilling/OriginalBillEntry/BillingRules'

// 账单导出

import BillingExport from '@/components/ebilling/OriginalBillEntry/BillingExport'

import Loading from '@/components/configuration/permissions_configuration_management/user/Loading'

Vue.use(Router)


export const constantRouterMap = [
  {
    path: '/loading',
    name: 'Loading',
    component: Loading
  },
  //启动的时候直接跳转到登录
  // {
  //   path: '/',
  //   name: 'Login',
  //   component: Login
  // },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login
  // },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/selectVersion',
    name: 'SelectVersion',
    component:SelectVersion
  },
  {
    path: '/pageManual',
    name: 'PageManual',
    component:PageManual
  },
  // 新菜单结构
  {
    path: '/dashboardHome',
    component: Main,
    children: [
      {
        path: '/dashboardHome',
        component: DashboardHome,
        type: 'ios-ionitron-outline',
        meta: {
          title: '仪表盘',
          order: "0-4",
          requireAuth: true
        }
      },

    ]
  },
  {
    path:'/ruleEngine',
    component: Main,
    children:[
      {
        path: '/ruleEngine',
        component: RuleEngine,
        type:'ios-disc-outline',
        meta: {
          title:'规则引擎',
          order:"0-5",
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/monitor',
    component: Main,
    type: "ios-eye-outline",
    meta: {
      title: '监控告警管理',
      order: "1",
      requireAuth: true
    },
    children: [
      {
        path: '/monitor/resource',
        component: ThirdMainResource,
        meta: {
          title: '资源',
          order: "1-1",
          requireAuth: true
        },
        children: [
          {
            path: '/monitor/elasticComputeCloudMonitor',
            component: ElasticComputeCloudMonitor,
            meta: {
              title: '实例',
              order: "1-1-01",
              requireAuth: true,
              btnPermissions: [
                'monitor:elasticComputeCloudMonitor:page',
                'monitor:elasticComputeCloudMonitor:export','monitor:elasticComputeCloudMonitor:add_alert_rule', 'monitor:elasticComputeCloudMonitor:detail', 'monitor:elasticComputeCloudDetail:overview', 'monitor:instance:refresh', 'monitor:elasticComputeCloudDetail:alert_rule', 'monitor:elasticComputeCloudMonitor:delete']

            }
          },
          {
            path: '/monitor/elasticComputeCloudDetail',
            component: ElasticComputeCloudDetail,
            meta: {
              title: '实例',
              order: "1-1-01",
              requireAuth: true
            }
          },
          {
            path: '/monitor/elasticComputeCloudWarning',
            component: ElasticComputeCloudWarning,
            meta: {
              title: '实例',
              order: "1-1-01",
              requireAuth: true
            }
          },
          {
            path: '/monitor/instance',
            component: Instance,
            meta: {
              title: '实例',
              order: "1-1-01",
              requireAuth: true
            }
          },
          // 新增 查看预测监控概况
          {
            path: '/monitor/instanceForecast',
            component: InstanceForecast,
            meta: {
              title: '实例',
              order: "1-1-01",
              requireAuth: true
            }
          },
          {
            path: '/monitor/elasticBlockStoreMonitor',
            component: ElasticBlockStoreMonitor,
            meta: {
              title: '磁盘',
              order: "1-1-03",
              requireAuth: true,
              btnPermissions: [
                'monitor:elasticBlockStoreMonitor:page',
                'monitor:elasticBlockStoreMonitor:export',
                'monitor:elasticBlockStoreMonitor:log',
                'monitor:elasticBlockStoreMonitor:alert_rule_edit',
                'monitor:elasticBlockStoreMonitor:alert_rule_delete',
                'monitor:elasticBlockStoreMonitor:add_alert_rule', 'monitor:elasticBlockStoreMonitor:detail', 'monitor:elasticBlockStoreDetail:overview', 'monitor:ebs:refresh', 'monitor:elasticBlockStoreDetail:alert_rule', 'monitor:elasticBlockStoreMonitor:delete']

            }
          },
          {
            path: '/monitor/elasticBlockStoreDetail',
            component: ElasticBlockStoreDetail,
            meta: {
              title: '磁盘',
              order: "1-1-03",
              requireAuth: true
            }
          },
          {
            path: '/monitor/elasticBlockStoreWarning',
            component: ElasticBlockStoreWarning,
            meta: {
              title: '磁盘',
              order: "1-1-03",
              requireAuth: true
            }
          },
          {
            path: '/monitor/ebs',
            component: EBS,
            meta: {
              title: '磁盘',
              order: "1-1-03",
              requireAuth: true
            }
          },
          // 新增 查看预测监控概况
          {
            path: '/monitor/ebsForecast',
            component: EBSForecast,
            meta: {
              title: '磁盘',
              order: "1-1-03",
              requireAuth: true
            }
          },
          {
            path: '/monitor/relationalDatabaseServiceMonitor',
            component: RelationalDatabaseServiceMonitor,
            meta: {
              title: '数据库',
              order: "1-1-04",
              requireAuth: true,
              btnPermissions: [
                'monitor:relationalDatabaseServiceMonitor:page',
                'monitor:relationalDatabaseServiceMonitor:export_statistics',
                'monitor:relationalDatabaseServiceMonitor:log',
                'monitor:relationalDatabaseServiceMonitor:alert_rule_edit',
                'monitor:relationalDatabaseServiceMonitor:alert_rule_delete',
                'monitor:relationalDatabaseServiceMonitor:add_alert_rule', 'monitor:relationalDatabaseServiceMonitor:detail', 'monitor:relationalDatabaseServiceDetail:overview', 'monitor:RDS:refresh', 'monitor:relationalDatabaseServiceDetail:alert_rule', 'monitor:relationalDatabaseServiceMonitor:export', 'monitor:relationalDatabaseServiceMonitor:delete']

            }
          },
          {
            path: '/monitor/relationalDatabaseServiceDetail',
            component: RelationalDatabaseServiceDetail,
            meta: {
              title: '数据库',
              order: "1-1-04",
              requireAuth: true
            }
          },
          {
            path: '/monitor/RelationalDatabaseServiceWarning',
            component: RelationalDatabaseServiceWarning,
            meta: {
              title: '数据库',
              order: "1-1-04",
              requireAuth: true
            }
          },
          {
            path: '/monitor/RDS',
            component: RDS,
            meta: {
              title: '数据库',
              order: "1-1-04",
              requireAuth: true
            }
          },
          // 新增 查看预测监控概况
          {
            path: '/monitor/RDSForecast',
            component: RDSForecast,
            meta: {
              title: '数据库',
              order: "1-1-04",
              requireAuth: true
            }
          },
          {
            path: '/monitor/elasticResourceAli',
            component: ElasticResourceAli,
            meta: {
              title: '弹性IP',
              order: "1-1-11",
              requireAuth: true,
              btnPermissions: [
                'monitor:elasticResourceAli:page',
                'monitor:elasticResourceAli:log',
                'monitor:elasticResourceAli:edit_alert_rule',
                'monitor:elasticResourceAli:delete_alert_rule',
                'monitor:elasticResourceAli:add_alert_rule','monitor:elasticResourceAli:queryEipByAllocationId','monitor:elasticResource:detail', 'monitor:elasticResourceDetail:overview', 'monitor:elasticResourceInstance:refresh', 'monitor:elasticResourceAli:delete']
            }
          },
          {
            path: '/monitor/ElasticResourceDetailAli',
            component: ElasticResourceDetailAli,
            meta: {
              title: '弹性IP',
              order: "1-1-11",
              requireAuth: true
            }
          },
          {
            path: '/monitor/TableElasticResourceAliWarning',
            component: TableElasticResourceAliWarning,
            meta: {
              title: '弹性IP',
              order: "1-1-11",
              requireAuth: true
            }
          },
          {
            path: '/monitor/ElasticResourceAliWarning',
            component: ElasticResourceAliWarning,
            meta: {
              title: '弹性IP',
              order: "1-1-11",
              requireAuth: true
            }
          },
          {
            path: '/monitor/InstanceAli',
            component: InstanceAli,
            meta: {
              title: '弹性IP',
              order: "1-1-11",
              requireAuth: true
            }
          },
          {
            path: '/monitor/redshiftMonitor',
            component: RedshiftMonitor,
            meta: {
              title: '数据仓库',
              order: "1-1-06",
              requireAuth: true,
              btnPermissions: [
                'monitor:redshiftMonitor:page',
                'monitor:redshiftMonitor:add_alert_rule', 'monitor:redshiftMonitor:detail', 'monitor:redshiftDetail:overview', 'monitor:redshiftDetail:alert_rule', 'monitor:redshiftMonitor:delete']

            }
          },
          {
            path: '/monitor/redshiftDetail',
            component: RedshiftDetail,
            meta: {
              title: '数据仓库',
              order: "1-1-06",
              requireAuth: true
            }
          },
          {
            path: '/monitor/DocDBMonitor/DocDBDetail',
            component: DocDBDetail,
            meta: {
              title: 'DocDB',
              order: "1-1-06",
              requireAuth: true,
            }
          },
          {
            path: '/monitor/redshiftWarning',
            component: RedshiftWarning,
            meta: {
              title: '数据仓库',
              order: "1-1-06",
              requireAuth: true
            }
          },
          {
            path: '/monitor/DocDBMonitor/DocDBWarning',
            component: DocDBWarning,
            meta: {
              title: 'DocDBWarning',
              order: "1-1-06",
              requireAuth: true
            }
          },
          {
            path: '/monitor/redshift',
            component: Redshift,
            meta: {
              title: '数据仓库',
              order: "1-1-06",
              requireAuth: true
            }
          },
          {
            path: '/monitor/DocDBMonitor/DocDB',
            component: DocDB,
            meta: {
              title: 'DocDB',
              order: "1-1-06",
              requireAuth: true,
              btnPermissions: ['monitor:DocDBMonitor:page']
            }
          },
          {
            path: '/monitor/elasticsearchMonitor',
            component: ElasticsearchMonitor,
            meta: {
              title: 'Elasticsearch',
              order: "1-1-09",
              requireAuth: true,
              btnPermissions: [
                'monitor:elasticsearchMonitor:page',
                'monitor:elasticsearchMonitor:add_alert_rule', 'monitor:elasticsearchMonitor:detail', 'monitor:elasticsearchDetail:overview', 'monitor:elasticsearchDetail:alert_rule', 'monitor:elasticsearchMonitor:delete']

            }
          },
          {
            path: '/monitor/elasticsearchDetail',
            component: ElasticsearchDetail,
            meta: {
              title: 'Elasticsearch',
              order: "1-1-09",
              requireAuth: true
            }
          },
          {
            path: '/monitor/elasticsearchWarning',
            component: ElasticsearchWarning,
            meta: {
              title: 'Elasticsearch',
              order: "1-1-09",
              requireAuth: true
            }
          },
          {
            path: '/monitor/elasticsearch',
            component: Elasticsearch,
            meta: {
              title: 'Elasticsearch',
              order: "1-1-09",
              requireAuth: true
            }
          },
          {
            path: '/elasticache',
            component: ThirdMainRedis,
            meta: {
              title: 'Elasticache',
              order: "1-1-10",
              requireAuth: true
            },
            children: [
              {
                path: '/elasticache/redisMonitor',
                component: RedisMonitor,
                meta: {
                  title: 'Redis',
                  order: "1-1-10-1",
                  requireAuth: true,
                  btnPermissions: [
                    'elasticache:redisMonitor:page',
                    'elasticache:redisMonitor:log',
                    'elasticache:redisMonitor:edit_alert_rule',
                    'elasticache:redisMonitor:delete_alert_rule',
                    'elasticache:redisMonitor:add_alert_rule','elasticache:redisMonitor:getAwsCacheDetailById','elasticache:redisMonitor:delete']
                }
              },
              {
                path: '/elasticache/redisDetail',
                component: RedisDetail,
                meta: {
                  title: 'Redis',
                  order: "1-1-10-1",
                  requireAuth: true
                }
              },
              {
                path: '/elasticache/redisWarning',
                component: RedisWarning,
                meta: {
                  title: 'Redis',
                  order: "1-1-10-1",
                  requireAuth: true
                }
              },
              {
                path: '/elasticache/redis',
                component: Redis,
                meta: {
                  title: 'Redis',
                  order: "1-1-10-1",
                  requireAuth: true
                }
              },

            ]
          },
          {
            path: '/nonCloudResources',
            component: ThirdMainWebsiteHealthStatus,
            meta: {
              title: '非云资源',
              order: "1-1-14",
              requireAuth: true
            },
            children: [
              {
                path: '/nonCloudResources/mailbox',
                component: Mailbox,
                meta: {
                  title: '邮箱',
                  order: "1-1-14-1",
                  requireAuth: true,
                  btnPermissions: [
                    'nonCloudResources:mailbox:edit_alert_rule',
                    'nonCloudResources:mailbox:delete_alert_rule',
                    'nonCloudResources:mailbox:log',
                    'nonCloudResources:mailbox:add_alert_rule']
                }
              },
              {
                path: '/nonCloudResources/websiteHealthStatus',
                component: WebsiteHealthStatus,
                meta: {
                  title: '网站健康状态',
                  order: "1-1-14-2",
                  requireAuth: true,
                  btnPermissions: [
                    'nonCloudResources:websiteHealthStatus:log',
                    'nonCloudResources:websiteHealthStatus:edit_alert_rule',
                    'nonCloudResources:websiteHealthStatus:delete_alert_rule',
                    'nonCloudResources:websiteHealthStatus:add_alert_rule']
                }
              }
            ]
          },
          {
            path: '/monitor/storageGateway',
            component: StorageGateway,
            meta: {
              title: 'StorageGateway',
              order: "1-1-17",
              requireAuth: true
            }
          },
          {
            path: '/monitor/storageGatewayMonitor',
            component: StorageGatewayMonitor,
            meta: {
              title: 'StorageGateway',
              order: "1-1-20",
              requireAuth: true,
              btnPermissions: [
                'monitor:storageGatewayMonitor:page',
                'monitor:storageGatewayMonitor:add_alert_rule','monitor:storageGatewayMonitor:getStorageGatewayDetailById', 'monitor:storageGatewayMonitor:detail', 'monitor:storageGatewayDetail:overview', 'monitor:storageGatewayDetail:alert_rule', 'monitor:storageGatewayMonitor:delete']
            }
          },
          {
            path: '/monitor/storageGatewayDetail',
            component: StorageGatewayDetail,
            meta: {
              title: 'StorageGateway',
              order: "1-1-17",
              requireAuth: true
            }
          },
          {
            path: '/monitor/storageGatewayWarning',
            component: StorageGatewayWarning,
            meta: {
              title: 'StorageGateway',
              order: "1-1-17",
              requireAuth: true
            }
          },
          {
            path: '/monitor/billingMonitor',
            component: BillingMonitor,
            meta: {
              title: '财务',
              order: "1-1-16",
              requireAuth: true,
              btnPermissions: [
                'monitor:billingMonitor:page',
                'monitor:billingMonitor:add_alert_rule', 'monitor:billingMonitor:log', 'monitor:billingMonitor:edit', 'monitor:billingMonitor:delete']

            }
          },
          {
            path: '/logs',
            component: ThirdMainLogs,
            meta: {
              title: '日志',
              order: "1-1-17",
              requireAuth: true
            },
            children: [
              {
                path: '/logs/logMonitor',
                component: LogMonitor,
                meta: {
                  title: '应用',
                  order: "1-1-17-1",
                  requireAuth: true,
                  btnPermissions: [
                    'logs:logMonitor:page',
                    'logs:logMonitor:delete',
                    'logs:logMonitor:add_alert_rule', 'logs:logMonitor:log', 'logs:logMonitor:edit', 'logs:logMonitor:delete']

                }
              },
              {
                path: '/logs/security',
                component: Security,
                meta: {
                  title: '安全(ActionTrail)',
                  order: "1-1-17-2",
                  requireAuth: true,
                  btnPermissions: ['logs:security:search']

                }
              },
              {
                path: '/logs/cloudTrail',
                component: CloudTrail,
                meta: {
                  title: '安全(CloudTrail)',
                  order: "1-1-17-3",
                  requireAuth: true,
                  btnPermissions: [
                    'logs:cloudTrail:page',
                    'logs:cloudTrail:add_alert_rule', 'logs:cloudTrail:search', 'logs:cloudTrail:export', 'logs:cloudTrail:log', 'logs:cloudTrail:edit', 'logs:cloudTrail:delete']

                }
              }
            ]
          },
          {
            path: '/monitor/messageQueueMonitor',
            component: MessageQueueMonitor,
            meta: {
              title: '队列',
              order: "1-1-08",
              requireAuth: true,
              btnPermissions: [
                'monitor:messageQueueMonitor:page',
                'monitor:messageQueueMonitor:delete',
                'monitor:messageQueueMonitor:detail',
                'monitor:messageQueueMonitor:add_alert_rule']

            }
          },
          {
            path: '/monitor/messageQueueDetail',
            component: MessageQueueDetail,
            meta: {
              title: '队列',
              order: "1-1-08",
              requireAuth: true
            }
          },
          {
            path: '/monitor/messageQueue',
            component: MessageQueue,
            meta: {
              title: '队列',
              order: "1-1-08",
              requireAuth: true
            }
          },
          {
            path: '/monitor/objectStorageMonitor',
            component: ObjectStorageMonitor,
            meta: {
              title: '对象存储',
              order: "1-1-07",
              requireAuth: true,
              btnPermissions: [
                'monitor:objectStorageMonitor:page',
                'monitor:objectStorageMonitor:queryBucketByName','monitor:objectStorageMonitor:delete']
            }
          },
          {
            path: '/monitor/objectStorageDetail',
            component: ObjectStorageDetail,
            meta: {
              title: '对象存储',
              order: "1-1-07",
              requireAuth: true
            }
          },
          {
            path: '/monitor/objectStorage',
            component: ObjectStorage,
            meta: {
              title: '对象存储',
              order: "1-1-07",
              requireAuth: true
            }
          },
          {
            path: '/monitor/trustAdvisor',
            component: TrustAdvisor,
            meta: {
              title: 'TrustAdvisor',
              order: "1-1-23",
              requireAuth: true,
              btnPermissions: [
                '',
                'monitor:trustAdvisor:add_alert_rule','monitor:trustAdvisor:log',
                'monitor:trustAdvisor:edit','monitor:trustAdvisor:delete']
            }
          },
          {
            path: '/monitor/trustAdvisorDetail',
            component: TrustAdvisorDetail,
            meta: {
              title: 'TrustAdvisor详情',
              order: "1-1-23",
              requireAuth: true
            }
          },
          {
            path: '/monitor/weeklyReport',
            component: WeeklyReport,
            meta: {
              title: 'WeeklyReport',
              order: "1-1-18",
              requireAuth: true,
              btnPermissions: [
                'monitor:weeklyReport:edit_alert_rule',
                'monitor:weeklyReport:delete_alert_rule',
                'monitor:weeklyReport:add_alert_rule','monitor:weeklyReport:log',
                'monitor:weeklyReport:edit','monitor:weeklyReport:delete']
            }
          },
          {
            path: '/monitor/complianceChecks',
            component: ComplianceChecks,
            meta: {
              title: '合规检查',
              order: "1-1-22",
              requireAuth: true,
              btnPermissions: [
                'monitor:complianceChecks:page',
                'monitor:complianceChecks:white_list_page',
                'monitor:complianceChecks:log',
                'monitor:complianceChecks:edit_alert_rule',
                'monitor:complianceChecks:delete_alert_rule',
                'monitor:complianceChecks:add_alert_rule','monitor:complianceChecks:queryConfigRuleCheckItemsDetail','monitor:complianceChecks:ignoreNoncompliantResources',
                'monitor:complianceChecks:deleteIgnoreNoncompliantResources']
            }
          },
          {
            path: '/monitor/complianceChecksDetail',
            component: ComplianceChecksDetail,
            meta: {
              title: '合规检查详情',
              order: "1-1-22",
              requireAuth: true
            }
          },
          {
            path: '/monitor/cloudUserMonitor',
            component: CloudUserMonitor,
            meta: {
              title: '云用户',
              order: "1-1-21",
              requireAuth: true,
              btnPermissions: [
                'monitor:cloudUserMonitor:page',
                'monitor:cloudUserMonitor:add_alert_rule','monitor:cloudUserMonitor:getCloudUserDetailById','monitor:cloudUserMonitor:delete']
            }
          },
          {
            path: '/monitor/cloudUserDetail',
            component: CloudUserDetail,
            meta: {
              title: '云用户',
              order: "1-1-21",
              requireAuth: true
            }
          },
          {
            path: '/monitor/cloudUserWarning',
            component: CloudUserWarning,
            meta: {
              title: '云用户',
              order: "1-1-21",
              requireAuth: true
            }
          },
          {
            path: '/monitor/affectedResourcesDetail',
            component: AffectedResourcesDetail,
            meta: {
              title: '受影响资源列表',
              order: "1-1-12",
              requireAuth: true
            }
          },
          {
            path: '/monitor/logManagementMonitor',
            component: LogManagementMonitor,
            meta: {
              title: '日志服务（阿里云SLS）',
              order: "1-1-24",
              requireAuth: true,
              btnPermissions: [
                'monitor:logManagementMonitor:page',
                'monitor:logManagementMonitor:queryLogDetails']
            }
          },
          {
            path: '/monitor/logManagementDetail',
            component: LogManagementDetail,
            meta: {
              title: '日志服务（阿里云SLS）',
              order: "1-1-24",
              requireAuth: true
            }
          },
          {
            path: '/monitor/logManagement',
            component: LogManagement,
            meta: {
              title: '日志服务（阿里云SLS）',
              order: "1-1-24",
              requireAuth: true
            }
          },
          {
            path: '/network',
            component: ThirdMain,
            meta: {
              title: '网络',
              order: "1-1-02",
              requireAuth: true
            },
            children: [
              {
                path: '/network/cenMonitor',
                component: CenMonitor,
                meta: {
                  title: 'CEN',
                  order: "1-1-02-1",
                  requireAuth: true,
                  btnPermissions: [
                    'network:cenMonitor:page',
                    'network:cenMonitor:queryCenByCenId']
                }
              },
              {
                path: '/network/cenDetail',
                component: CenDetail,
                meta: {
                  title: 'CEN',
                  order: "1-1-02-1",
                  requireAuth: true
                }
              },
              {
                path: '/network/cen',
                component: CEN,
                meta: {
                  title: 'CEN',
                  order: "1-1-02-1",
                  requireAuth: true
                }
              },
              {
                path: '/network/slbMonitor',
                component: SlbMonitor,
                meta: {
                  title: '负载均衡',
                  order: "1-1-02-2",
                  requireAuth: true,
                  btnPermissions: [
                    'network:slbMonitor:log',
                    'network:slbMonitor:delete_alert_rule',
                    ' network:slbMonitor:edit_alert_rule',
                    'network:slbMonitor:page',
                    'network:slbMonitor:add_alert_rule', 'network:slbMonitor:detail', 'network:slbDetail:overview', 'network:slb:refresh', 'network:slbDetail:alert_rule', 'network:slbMonitor:delete']

                }
              },
              {
                path: '/network/slbWarning',
                component: SlbWarning,
                meta: {
                  title: '负载均衡',
                  order: "1-1-02-2",
                  requireAuth: true
                }
              },
              {
                path: '/network/slbDetail',
                component: SlbDetail,
                meta: {
                  title: '负载均衡',
                  order: "1-1-02-2",
                  requireAuth: true
                }
              },
              {
                path: '/network/slb',
                component: SLB,
                meta: {
                  title: '负载均衡',
                  order: "1-1-02-2",
                  requireAuth: true
                }
              },
              {
                path: '/network/agwMonitor',
                component: AgwMonitor,
                meta: {
                  title: '应用程序网关(Azure)',
                  order: "1-1-02-3",
                  requireAuth: true,
                  btnPermissions: [
                    'network:agwMonitor:page',
                    'network:agwMonitor:add_alert_rule', 'network:agwMonitor:detail', 'network:agwDetail:overview', 'network:agwDetail:alert_rule', 'network:agwMonitor:delete']

                }
              },
              {
                path: '/network/agwDetail',
                component: AgwDetail,
                meta: {
                  title: '应用程序网关(Azure)',
                  order: "1-1-02-3",
                  requireAuth: true
                }
              },
              {
                path: '/network/agwWarning',
                component: AgwWarning,
                meta: {
                  title: '应用程序网关(Azure)',
                  order: "1-1-02-3",
                  requireAuth: true
                }
              },
              {
                path: '/network/agw',
                component: AGW,
                meta: {
                  title: '应用程序网关(Azure)',
                  order: "1-1-02-3",
                  requireAuth: true
                }
              },
              {
                path: '/network/webMonitor',
                component: WebMonitor,
                meta: {
                  title: '应用程序(Azure)',
                  order: "1-1-02-4",
                  requireAuth: true,
                  btnPermissions: [
                    'network:webMonitor:export',
                    'network:webMonitor:page',
                    'network:webMonitor:add_alert_rule', 'network:webMonitor:detail', 'network:slbDetail:overview', 'network:slbDetail:alert_rule', 'network:webMonitor:delete']

                }
              },
              {
                path: '/network/webDetail',
                component: WebDetail,
                meta: {
                  title: '应用程序(Azure)',
                  order: "1-1-02-4",
                  requireAuth: true
                }
              },
              {
                path: '/network/webWarning',
                component: WebWarning,
                meta: {
                  title: '应用程序(Azure)',
                  order: "1-1-02-4",
                  requireAuth: true
                }
              },
              {
                path: '/network/web',
                component: WEB,
                meta: {
                  title: '应用程序(Azure)',
                  order: "1-1-02-4",
                  requireAuth: true
                }
              },
              {
                path: '/network/natMonitor',
                component: NatMonitor,
                meta: {
                  title: 'Nat网关',
                  order: "1-1-02-5",
                  requireAuth: true,
                  btnPermissions: [
                    'network:natMonitor:page',
                    'network:natMonitor:detail', 'network:natDetail:overview', 'network:instance:refresh', 'network:natDetail:alert_rule', 'network:natMonitor:delete']

                }
              },
              {
                path: '/network/natDetail',
                component: NatDetail,
                meta: {
                  title: 'Nat网关',
                  order: "1-1-02-5",
                  requireAuth: true
                }
              },
              {
                path: '/network/InstanceNat',
                component: InstanceNat,
                meta: {
                  title: 'Nat网关',
                  order: "1-1-02-5",
                  requireAuth: true
                }
              },
            ]
          },

          {
            path: '/monitor/autoscalingMonitor',
            component: AutoscalingMonitor,
            meta: {
              title: 'Autoscaling',
              order: "1-1-12",
              requireAuth: true,
              btnPermissions: [
                'monitor:autoscalingMonitor:page',
                'monitor:autoscalingMonitor:detail', 'monitor:autoscalingDetail:overview', 'monitor:instance:refresh', 'monitor:autoscalingDetail:alert_rule', 'monitor:autoscalingMonitor:delete']

            }
          },
          {
            path: '/monitor/autoscalingDetail',
            component: AutoscalingDetail,
            meta: {
              title: 'Autoscaling',
              order: "1-1-12",
              requireAuth: true
            }
          },
          {
            path: '/monitor/InstanceAutoscaling',
            component: InstanceAutoscaling,
            meta: {
              title: 'Autoscaling',
              order: "1-1-12",
              requireAuth: true
            }
          },
          {
            path: '/monitor/PerformanceInsights',
            component: PerformanceInsights,
            meta: {
              title: 'PerformanceInsights',
              order: "1-1-05",
              requireAuth: true,
            }
          },
          {
            path: '/monitor/webApplicationFirewallMonitor',
            component: WebApplicationFirewallMonitor,
            meta: {
              title: 'Web应用防火墙',
              order: "1-1-13",
              requireAuth: true,
              btnPermissions: [
                'monitor:WebApplicationFirewallMonitor:page',
                'monitor:webApplicationFirewallMonitor:detail', 'monitor:webApplicationFirewallDetail:overview', 'monitor:instance:refresh', 'monitor:webApplicationFirewallDetail:alert_rule', 'monitor:webApplicationFirewallMonitor:delete']

            }
          },
          {
            path: '/monitor/webApplicationFirewallDetail',
            component: WebApplicationFirewallDetail,
            meta: {
              title: 'Web应用防火墙',
              order: "1-1-13",
              requireAuth: true
            }
          },
          {
            path: '/monitor/InstanceWebApplicationFirewall',
            component: InstanceWebApplicationFirewall,
            meta: {
              title: 'Web应用防火墙',
              order: "1-1-13",
              requireAuth: true
            }
          },
          {
            path: '/monitor/backPlanMonitor',
            component: BackPlanMonitor,
            meta: {
              title: '备份计划',
              order: "1-1-15",
              requireAuth: true,
              btnPermissions: [
                'monitor:backPlanMonitor:page',
                'monitor:backPlanMonitor:log',
                'monitor:backPlanMonitor:edit_alert_rule',
                'monitor:backPlanMonitor:delete_alert_rule',
                'monitor:backPlanMonitor:add_alert_rule', 'monitor:backPlanMonitor:detail', 'monitor:backPlanDetail:alert_rule', 'monitor:backPlanMonitor:delete']

            }
          },
          {
            path: '/monitor/backPlanDetail',
            component: BackPlanDetail,
            meta: {
              title: '备份计划',
              order: "1-1-15",
              requireAuth: true
            }
          },
          {
            path: '/monitor/backPlanWarning',
            component: BackPlanWarning,
            meta: {
              title:'备份计划',
              order: "1-1-15",
              requireAuth: true
            }
          },
          {
            path: '/monitor/DocDBMonitor',
            component: DocDBMonitor,
            meta: {
              title: 'DocDB',
              order: "1-1-24",
              requireAuth: true,
              btnPermissions: [
                'monitor:DocDBMonitor:delete_alert_rule',
                'monitor:DocDBMonitor:edit_alert_rule',
                'monitor:DocDBMonitor:page',
                'monitor:DocDBMonitor:log',
                'monitor:DocDBMonitor:edit',
                'monitor:DocDBMonitor:add_alert_rule', 'monitor:DocDBMonitor:detail', 'monitor:DocDBMonitor:overview', 'monitor:DocDBMonitor:alert_rule', 'monitor:DocDBMonitor:delete']
            }
          },
          {
            path: '/aiMonitor',
            type: 'logo-reddit',
            component: ThirdMainAIMonitor,
            meta: {
              title: '智能监控',
              order: "1-1-19",
              requireAuth: true
            },
            children: [
              {
                path: '/aiMonitor/aiDashboard',
                component: AIDashboard,
                meta: {
                  title: '仪表盘',
                  order: "1-1-19-1",
                  requireAuth: true
                }
              },
              {
                path: '/aiMonitor/instanceDetail',
                component: InstanceDetail,
                meta: {
                  title: '仪表盘',
                  order: "1-1-19-1",
                  requireAuth: true
                }
              },
              {
                path: '/aiMonitor/databaseDetail',
                component: DatabaseDetail,
                meta: {
                  title: '仪表盘',
                  order: "1-1-19-1",
                  requireAuth: true
                }
              },
              {
                path: '/aiMonitor/operatingSystem',
                component: OperatingSystem,
                meta: {
                  title: '应用系统',
                  order: "1-1-19-2",
                  requireAuth: true,
                  btnPermissions: ['aiMonitor:operatingSystem:application_config', 'aiMonitor:applicationConfiguration:add_instance', 'aiMonitor:applicationConfiguration:add_database', 'aiMonitor:operatingSystem:add_application', 'aiMonitor:operatingSystem:delete']

                }
              },
              {
                path: '/aiMonitor/applicationConfiguration',
                component: ApplicationConfiguration,
                meta: {
                  title: '应用系统',
                  order: "1-1-19-2",
                  requireAuth: true
                }
              },
              {
                path: '/aiMonitor/applicationSystemAlarm',
                component: ApplicationSystemAlarm,
                meta: {
                  title: '应用系统告警',
                  order: "1-1-19-3",
                  requireAuth: true,
                  btnPermissions: ['aiMonitor:applicationSystemAlarm:detail', 'aiMonitor:applicationSystemAlarm:return']

                }
              }
            ]
          }
        ]
      },
      {
        path: '/monitor/resourceGroup',
        component: ResourceGroup,
        meta: {
          title: '资源组',
          order: "1-2",
          requireAuth: true,
          btnPermissions: [
            'monitor:resourceGroupMonitor:page',
            'monitor:resourceGroupMonitor:add','monitor:resourceGroupMonitor:delete', 'monitor:resourceGroupMonitor:detail', 'monitor:resourceGroupMonitor:operationLog', 'monitor:resourceGroupMonitor:resourceSyncLog']
        }
      },
      {
        path: '/monitor/addOrUpdateResourceGroup',
        component: addOrUpdateResourceGroup,
        meta: {
          title: '资源组',
          order: "1-2",
          requireAuth: true
        }
      },
    ],
  },
  {
    path: '/ticketCenter',
    component: Main,
    type: "ios-briefcase-outline",
    meta: {
      title: '工单中心',
      order: "2",
      requireAuth: true
    },
    children: [
      {
        path: '/ticketCenter/case',
        component: Case,
        meta: {
          title: '列表',
          order: "2-1",
          btnPermissions: [
            'cases:case:import',
            'cases:case:export', 'cases:case:add', 'cases:case:cancel', 'cases:case:confirm', 'cases:case:edit', 'cases:case:process', 'cases:case:delete', 'cases:case:detail', 'cases:caseDetail:export', 'cases:caseDetail:comment', 'cases:caseDetail:return', 'cases:caseDetail:download'],
          requireAuth: true
        }
      },
      {
        path: '/cases/caseDetail',
        component: CaseDetail,
        meta: {
          title: '列表',
          order: "2-1",
          requireAuth: true
        }
      },
      {
        path: '/cases/keyPerformanceIndication',
        component: KeyPerformanceIndication,
        meta: {
          title: 'KPI',
          order: "2-4",
          requireAuth: true
        }
      },
      {
        path: '/cases/satisfaction',
        component: Satisfaction,
        meta: {
          title: '满意度',
          order: "2-5",
          requireAuth: true,
          btnPermissions: ['cases:satisfaction:search', 'cases:satisfaction:detail']
        }
      },
      {
        path: '/approvalTask',
        component: ApprovalTask,
        type: 'ios-create-outline',
        meta: {
          title: '审批任务',
          order: "2-2",
          requireAuth: true,
          btnPermissions: ['approval_task:ApprovalTask:approvalDetail']
        }
      },
      {
        path: '/approvalTask/approvalTaskDetail',
        component: ApprovalTaskDetail,
        meta: {
          title: '审批任务详情',
          order: "2-2",
          requireAuth: true
        }
      },
      {
        path: '/approvalTask/dealwithDetail',
        component: DealwithDetail,
        meta: {
          title: '审批任务处理',
          order: "2-2",
          requireAuth: true
        }
      },
      {
        path: '/approvalFlowConfiguration',
        component: Ninth,
        meta: {
          title: '审批流配置',
          order: "2-3",
          requireAuth: true

        },
        children: [
          {
            path: '/approvalFlowConfiguration/approvalFlowConfiguration',
            component: ApprovalFlowConfiguration,
            meta: {
              title: '审批流',
              order: "2-3-2",
              requireAuth: true,
              btnPermissions: [
                'approvalFlowConfiguration:approvalFlowConfiguration:log',
                'approvalFlowConfiguration:approvalFlowConfiguration:add_approval_flow', 'approvalFlowConfiguration:approvalFlowConfiguration:edit', 'approvalFlowConfiguration:approvalFlowConfiguration:delete']

            }
          },
          {
            path: '/approvalFlowConfiguration/node',
            component: Node,
            meta: {
              title: '节点',
              order: "2-3-1",
              requireAuth: true,
              btnPermissions: [
                'approvalFlowConfiguration:node:log',
                'approvalFlowConfiguration:node:add_node', 'approvalFlowConfiguration:node:edit', 'approvalFlowConfiguration:node:delete']

            }
          }
        ]
      }
    ]
  },
  {
    path: '/ebilling',
    type: 'logo-bitcoin',
    component: Main,
    meta: {
      title: '账单中心',
      order: "3",
      requireAuth: true
    },
    children: [
      {
        path: '/ebilling/billingPage',
        component: BillingPage,
        meta: {
          title: '账单',
          order: "3-1",
          requireAuth: true
        }
      },
      {
        path: '/ebilling/slBillingPage',
        component: SlBillingPage,
        meta: {
          title: 'AWS账单页面',
          order: "3-9",
          requireAuth: true
        }
      },
      {
        path: '/ebilling/reserved_instance',
        component: Thirteenth,
        meta: {
          title: '预留实例',
          order: "3-2",
          requireAuth: true
        },
        children: [
          {
            path: '/ebilling/RIPage',
            component: RIPage,
            meta: {
              title: '太古RI页面',
              order: "3-2-1",
              requireAuth: true
            }
          },
          {
            path: '/ebilling/reserved_instance/utilization_report/utilizationReport',
            component: UtilizationReport,
            meta: {
              title: '利用率报告',
              order: "3-2-2",
              requireAuth: true
            }
          },
          {
            path: '/ebilling/reserved_instance/coverage_report/coverageReport',
            component: CoverageReport,
            meta: {
              title: '覆盖率报告',
              order: "3-2-3",
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/ebilling/gcp',
        component: ThirdMainLogs,
        meta: {
          title: 'GCP',
          order: "3-8",
          requireAuth: true
        },
        children: [
          {
            path: '/ebilling/discountConfiguration',
            component: DiscountConfiguration,
            meta: {
              title: '折扣配置',
              order: "3-8-1",
              requireAuth: true,
              btnPermissions: ['ebilling:discountConfiguration:updateDiscountConfig']
            }
          },
          {
            path: '/ebilling/cudRecommendationPage',
            component: CudRecommendationPage,
            meta: {
              title: 'CUD推荐页面',
              order: "3-8-2",
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/ebilling/costCalculation',
        component: CostCalculation,
        meta: {
          title: '成本计算',
          order: "3-10",
          requireAuth: true
        }
      },
      {
        path: '/ebilling/ebilling',
        component: ThirdMainLogs,
        meta: {
          title: 'ebilling',
          order: "3-11",
          requireAuth: true
        },
        children: [
          {
            path: '/ebilling/aws',
            component: AWS,
            meta: {
              title: 'AWS',
              order: "3-11-1",
              requireAuth: true
            }
          },
          {
            path: '/ebilling/azure',
            component: Azure,
            meta: {
              title: 'Azure',
              order: "3-11-2",
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/ebilling/costAllocation',
        component: CostAllocation,
        meta: {
          title: '成本分摊',
          order: "3-3",
          requireAuth: true
        }
      },
      {
        path: '/ebilling/addOrUpdateCostAllocation',
        component: AddOrUpdateCostAllocation,
        meta: {
          title: '成本分摊',
          order: "3-3",
          requireAuth: true
        }
      },
      {
        path: '/ebilling/resourceOptimization',
        component: ResourceOptimization,
        meta: {
          title: '资源优化',
          order: "3-4",
          requireAuth: true,
          btnPermissions: ['ebilling:resourceOptimization:resourceOptimizationDashboard']
        }
      },
      {
        path:'/ebilling/OriginalBillEntry',
        component:Thirteenth,
        meta:{
          title:'原始账单录入',
          order:'3-3',
          requireAuth:true
        },
        children:[
          {
            path:'/ebilling/OriginalBillEntry/aws',
            component:OriginalBillEntry,
            meta:{
              title:'aws',
              order:'3-3-1',
              requireAuth:true
            }
          }
        ]
      },
      {
        path:'/ebilling/BillingRules',
        component:BillingRules,
        meta:{
          title:'账单规则设置',
          order:'3-6',
          requireAuth:true
        },
      },
      {
        path:'/ebilling/BillingExport',
        component:BillingExport,
        meta:{
          title:'账单导出',
          order:'3-7',
          requireAuth:true
        },
      }
    ]
  },
  {
    path: '/selfService',
    type: 'logo-pinterest',
    component: Main,
    meta: {
      title: '自动化处理',
      order: "4",
      requireAuth: true
    },
    children: [
      {
        path: '/timerSwitchs',
        component: Thirteenth,
        meta: {
          title: '定时开关机',
          order: "4-1",
          requireAuth: true
        },
        children: [
          {
            path: '/timerSwitchs/serverSearchs',
            component: ServerSearchs,
            meta: {
              title: '查询',
              order: "4-1-1",
              requireAuth: true,
              btnPermissions: [
                'timerSwitchs:serverSearchs:add',
                'timerSwitchs:serverSearchs:task_search',
                'timerSwitchs:serverSearchs:task_export',
                'timerSwitchs:serverSearchs:search', 'timerSwitchs:serverSearchs:export']

            }
          }
        ]
      },
      {
        path: '/patchManagement',
        component: Thirteenth,
        meta: {
          title: '补丁管理',
          order: "4-2",
          requireAuth: true
        },
        children: [
          {
            path: '/patchManagement/patchMonitor',
            component: PatchMonitor,
            meta: {
              title: '补丁监视器',
              order: "4-2-1",
              requireAuth: true
            }
          },
          {
            path: '/patchManagement/policies',
            component: Policies,
            meta: {
              title: '补丁策略',
              order: "4-2-2",
              requireAuth: true,
              btnPermissions: ['patchManagement:policies:add_policy', 'patchManagement:policies:edit', 'patchManagement:policies:patch_baseline_config', 'patchManagement:patchBaselineConfiguration:add_patch_baseline', 'patchManagement:patchBaselineConfiguration:search_baseline', 'patchManagement:patchBaselineConfiguration:search_patch', 'patchManagement:policies:cmd_parameter', 'patchManagement:addOrUpdateRunCommands:cancel', 'patchManagement:addOrUpdateRunCommands:save', 'patchManagement:policies:delete', 'patchManagement:policies:excute']


            }
          },
          {
            path: '/patchManagement/patchBaselineConfiguration',
            component: PatchBaselineConfiguration,
            meta: {
              title: '补丁基准配置',
              order: "4-2-2",
              requireAuth: true
            }
          },
          {
            path: '/patchManagement/patchCommandParameters',
            component: PatchCommandParameters,
            meta: {
              title: '命令列表',
              order: "4-2-3",
              requireAuth: true,
              btnPermissions: ['patchManagement:patchCommandParameters:search']

            }
          },
          {
            path: '/patchManagement/commandDetail',
            component: CommandDetail,
            meta: {
              title: '命令详情',
              order: "4-2-3",
              requireAuth: true
            }
          },
          {
            path: '/patchManagement/addOrUpdateRunCommands',
            component: AddOrUpdateRunCommands,
            meta: {
              title: '运行命令',
              order: "4-2-3",
              requireAuth: true
            }
          },
          {
            path: '/patchManagement/commandHistoryDetail',
            component: CommandHistoryDetail,
            meta: {
              title: '命令历史记录',
              order: "4-2-3",
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/resourceLifecycleManagement',
        component: Thirteenth,
        type: "ios-flash-outline",
        meta: {
          title: '资源生命周期管理',
          order: "4-3",
          requireAuth: true
        },
        children: [
          {
            path: '/resourceLifecycleManagement/resourceServiceDirectory',
            component: ResourceServiceDirectory,
            meta: {
              title: '资源服务目录',
              order: "4-3-1",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication',
            component: ResourceApplication,
            meta: {
              title: '资源申请',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/aws/amazonVirtualMachineDetail',
            component: AmazonVirtualMachineDetail,
            meta: {
              title: '资源申请虚拟机AWS',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/aws/amazonVirtualNetworkDetail',
            component: AmazonVirtualNetworkDetail,
            meta: {
              title: '资源申请虚拟网络AWS',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/aws/amazonObjectStorageDetail',
            component: AmazonObjectStorageDetail,
            meta: {
              title: '资源申请对象存储AWS',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/aws/amazonManagedDatabaseDetail',
            component: AmazonManagedDatabaseDetail,
            meta: {
              title: '资源申请托管数据库AWS',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/aws/amazonElasticAddressDetail',
            component: AmazonElasticAddressDetail,
            meta: {
              title: '资源申请弹性IPAWS',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/azure/azureVirtualMachineDetail',
            component: AzureVirtualMachineDetail,
            meta: {
              title: '资源申请虚拟机Azure',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/azure/azureVirtualNetworkDetail',
            component: AzureVirtualNetworkDetail,
            meta: {
              title: '资源申请虚拟网络Azure',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/azure/azureObjectStorageDetail',
            component: AzureObjectStorageDetail,
            meta: {
              title: '资源申请对象存储Azure',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/azure/azureManagedDatabaseDetail',
            component: AzureManagedDatabaseDetail,
            meta: {
              title: '资源申请托管数据库Azure',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceApplication/azure/azureElasticAddressDetail',
            component: AzureElasticAddressDetail,
            meta: {
              title: '资源申请弹性IPAzure',
              order: "4-3-2",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceChange',
            component: ResourceChange,
            meta: {
              title: '资源变更',
              order: "4-3-3",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceRenewal',
            component: ResourceRenewal,
            meta: {
              title: '资源续约',
              order: "4-3-4",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceRecycle',
            component: ResourceRecycle,
            meta: {
              title: '资源回收',
              order: "4-3-5",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceDetail',
            component: ResourceDetail,
            meta: {
              title: '资源详情',
              order: "4-3-5",
              requireAuth: true
            }
          },
          {
            path: '/resourceLifecycleManagement/resourceServiceOperationReport',
            component: ResourceServiceOperationReport,
            meta: {
              title: '资源服务运营报告',
              order: "4-3-6",
              requireAuth: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/configuration',
    component: Main,
    type: "ios-construct-outline",
    meta: {
      title: '配置管理',
      order: "5",
      requireAuth: true
    },
    children: [
      {
        path: '/configurationManagement',
        component: Fourth,
        meta: {
          title: '报警配置管理',
          order: "5-1",
          requireAuth: true
        },
        children: [
          {
            path: '/configurationManagement/systemTask',
            component: SystemTask,
            meta: {
              title: '定时任务配置',
              order: "5-1-1",
              requireAuth: true,
              btnPermissions: ['configurationManagement:systemTask:delete', 'configurationManagement:systemTask:add_timed_task']

            }
          },
          {
            path: '/configurationManagement/customerDefinedAlarmConfiguration',
            component: CustomerDefinedAlarmConfiguration,
            meta: {
              title: '客户自定义报警配置',
              order: "5-1-2",
              requireAuth: true,
              btnPermissions: [
                'configurationManagement:customerDefinedAlarmConfiguration:except_resource',
                'configurationManagement:customerDefinedAlarmConfiguration:log',
                'configurationManagement:customerDefinedAlarmConfiguration:edit',
                'configurationManagement:customerDefinedAlarmConfiguration:changeStatus', 'configurationManagement:customerDefinedAlarmConfiguration:edit', 'configurationManagement:alertRuleLists', 'configurationManagement:alertRuleLists:export']

            }
          },
          {
            path: '/configurationManagement/alertRuleLists',
            component: AlertRuleLists,
            meta: {
              title: '报警规则一览表',
              order: "5-1-2",
              requireAuth: true
            }
          },
          {
            path: '/configurationManagement/exceptionResource',
            component: ExceptionResource,
            meta: {
              title: '例外资源',
              order: "5-1-2",
              requireAuth: true
            }
          },
          {
            path: '/configurationManagement/defaultAlarmConfiguration',
            component: DefaultAlarmConfiguration,
            meta: {
              title: '默认报警配置',
              order: "5-1-3",
              requireAuth: true,
              btnPermissions: ['configurationManagement:defaultAlarmConfiguration:add_default_alart_configuration', 'configurationManagement:defaultAlarmConfiguration:edit_default_alart_configuration']

            }
          },
          {
            path: '/configurationManagement/schedules',
            component: Schedules,
            meta: {
              title: '调度管理',
              order: "5-1-4",
              requireAuth: true,
              btnPermissions: ['configurationManagement:schedules:log', 'configurationManagement:schedules:add_schedule', 'configurationManagement:schedules:update', 'configurationManagement:schedules:delete']
            }
          },
          {
            path: '/configurationManagement/securityLogConfiguration',
            component: SecurityLogConfiguration,
            meta: {
              title: '安全日志配置',
              order: "5-1-5",
              requireAuth: true,
              btnPermissions: ['configurationManagement:securityLogConfiguration:configure']
            }
          },
          {
            path: '/configurationManagement/reservedInstancePurchase',
            component: ReservedInstancePurchase,
            meta: {
              title: '预留实例购买配置',
              order: "5-1-6",
              requireAuth: true,
              btnPermissions: ['configurationManagement:reservedInstancePurchase:log', 'configurationManagement:reservedInstancePurchase:update']
            }
          },
          {
            path: '/configurationManagement/monitorMailboxConfiguration',
            component: MonitorMailbox,
            meta: {
              title: '监控邮箱配置',
              order: "5-1-7",
              requireAuth: true,
              btnPermissions: [
                'configurationManagement:monitorMailboxConfiguration:log',
                'configurationManagement:monitorMailboxConfiguration:keyword_log',
                'configurationManagement:monitorMailboxConfiguration:create',
                'configurationManagement:monitorMailboxConfiguration:update',
                'configurationManagement:monitorMailboxConfiguration:delete',
                'configurationManagement:monitorMailboxKeyword:create',
                'configurationManagement:monitorMailboxKeyword:delete'
              ]
            }
          },
          {
            path: '/configurationManagement/monitorMailboxConfiguration',
            component: MonitorMailbox,
            meta: {
              title: '监控邮箱配置',
              order: "5-1-7",
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/permissionsConfigurationManagement',
        component: Fifth,
        meta: {
          title: '权限配置管理',
          order: "5-4",
          requireAuth: true
        },
        children: [
          {
            path: '/permissionsConfigurationManagement/accounts',
            component: Accounts,
            meta: {
              title: '账户',
              order: "5-4-1",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:accounts:log',
                'permissionsConfigurationManagement:accounts:add_account', 'permissionsConfigurationManagement:accounts:search_new_resources', 'permissionsConfigurationManagement:accounts:delete_account', 'permissionsConfigurationManagement:accounts:edit_account']

            }
          },
          {
            path: '/permissionsConfigurationManagement/permission',
            component: Permissions,
            meta: {
              title: '策略一览',
              order: "5-4-8",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:permission:search',
                'permissionsConfigurationManagement:permission:export']
            }
          },
          {
            path: '/permissionsConfigurationManagement/user',
            component: Users,
            meta: {
              title: '用户管理',
              order: "5-4-2",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:user:log',
                'permissionsConfigurationManagement:user:add_user',
                'permissionsConfigurationManagement:user:update_user',
                'permissionsConfigurationManagement:user:delete',
                'permissionsConfigurationManagement:user:reset'
              ]

            }
          },
          {
            path: '/permissionsConfigurationManagement/menuManagement',
            component: MenuManagement,
            meta: {
              title: '菜单管理',
              order: "5-4-7",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:menuManagement:log',
                'permissionsConfigurationManagement:menuManagement:create',
                'permissionsConfigurationManagement:menuManagement:update',
                'permissionsConfigurationManagement:menuManagement:delete'
              ]
            }
          },
          {
            path: '/permissionsConfigurationManagement/companyManagement',
            component: CompanyManagement,
            meta: {
              title: '公司管理',
              order: "5-4-3",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:companyManagement:log',
                'permissionsConfigurationManagement:companyManagement:add_company',
                'permissionsConfigurationManagement:companyManagement:activeDisableactiveDisable'
              ]

            }
          },
          {
            path: '/permissionsConfigurationManagement/roleManagement',
            component: RoleManagement,
            meta: {
              title: '角色管理',
              order: "5-4-4",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:roleManagement:log',
                'permissionsConfigurationManagement:roleManagement:add_role', 'permissionsConfigurationManagement:roleManagement:edit', 'permissionsConfigurationManagement:roleManagement:delete']

            }
          },
          {
            path: '/permissionsConfigurationManagement/addOrUpdateRoleManagement',
            component: AddOrUpdateRoleManagement,
            meta: {
              title: '角色管理',
              order: "5-4-4",
              requireAuth: true
            }
          },
          {
            path: '/permissionsConfigurationManagement/group',
            component: Groups,
            meta: {
              title: '组管理',
              order: "5-4-5",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:group:log',
                'permissionsConfigurationManagement:group:update',
                'permissionsConfigurationManagement:group:add_group', 'permissionsConfigurationManagement:group:resource_Permission', 'permissionsConfigurationManagement:resourcePermission:add_user', 'permissionsConfigurationManagement:resourcePermission:delete_user', 'permissionsConfigurationManagement:resourcePermission:add_account', 'permissionsConfigurationManagement:resourcePermission:delete_account', 'permissionsConfigurationManagement:resourcePermission:add_instance', 'permissionsConfigurationManagement:resourcePermission:delete_instance', 'permissionsConfigurationManagement:resourcePermission:add_disc', 'permissionsConfigurationManagement:resourcePermission:delete_disc', 'permissionsConfigurationManagement:resourcePermission:add_database', 'permissionsConfigurationManagement:resourcePermission:delete_database', 'permissionsConfigurationManagement:resourcePermission:add_virtual_desktop', 'permissionsConfigurationManagement:resourcePermission:delete_virtual_desktop', 'permissionsConfigurationManagement:resourcePermission:return', 'permissionsConfigurationManagement:group:delete']

            }
          },
          {
            path: '/permissionsConfigurationManagement/resourcePermission',
            component: ResourcePermission,
            meta: {
              title: '组管理',
              order: "5-4-5",
              requireAuth: true
            }
          },
          {
            path: '/permissionsConfigurationManagement/accountGroup',
            component: AccountGroup,
            meta: {
              title: '账户组管理',
              order: "5-4-6",
              requireAuth: true,
              btnPermissions: [
                'permissionsConfigurationManagement:accountGroupConfig:log',
                'permissionsConfigurationManagement:accountGroup:add_group', 'permissionsConfigurationManagement:accountGroup:accountGroup_config', 'permissionsConfigurationManagement:accountGroupConfig:account_config', 'permissionsConfigurationManagement:accountGroupConfig:delete', 'permissionsConfigurationManagement:accountGroup:edit', 'permissionsConfigurationManagement:accountGroup:delete']

            }
          },
          {
            path: '/permissionsConfigurationManagement/accountGroupConfig',
            component: AccountGroupConfig,
            meta: {
              title: '账户组管理',
              order: "5-4-6",
              requireAuth: true
            }
          }
        ]
      },
      {
        path: '/labelManagement',
        component: Ninth,
        meta: {
          title: '标签管理',
          order: "5-6",
          requireAuth: true
        },
        children: [
          {
            path: '/labelManagement/labelSynchronization',
            component: LabelSynchronization,
            meta: {
              title: '标签同步',
              order: "5-6-1",
              requireAuth: true,
              btnPermissions: ['labelManagement:labelSynchronization:update', 'labelManagement:labelSynchronization:sync']
            }
          },
          {
            path: '/labelManagement/tag',
            component: Tag,
            meta: {
              title: '标签处理',
              order: "5-6-2",
              requireAuth: true,
              btnPermissions: [
                'labelManagement:tag:resource_search',
                'labelManagement:tag:correct_add',
                'labelManagement:tag:correct_edit',
                'labelManagement:tag:correct_delete',
                'labelManagement:tag:add', 'labelManagement:tag:delete', 'labelManagement:tag:export']
            }
          },
          {
            path: '/labelManagement/TagMonitoring',
            component: TagMonitoring,
            meta: {
              title: '标签监控',
              order: "5-6-3",
              requireAuth: true,
              btnPermissions: [
                'labelManagement:tagMonitoring:page',
                'labelManagement:tagMonitoring:add', 'labelManagement:tagMonitoring:update', 'labelManagement:tagMonitoring:delete',
                'labelManagement:tagMonitoring:execute']
            }
          }
        ]
      },
      {
        path: '/resourceConfigurationManagement',
        component: Fifth,
        meta: {
          title: '资源管理',
          order: "5-3",
          requireAuth: true
        },
        children: [
          {
            path: '/resourceConfigurationManagement/aws',
            component: Sixth,
            meta: {
              title: 'AWS',
              order: "5-3-1",
              requireAuth: true
            },
            children: [
              {
                path: '/resourceConfigurationManagement/aws/elasticComputeCloudResource',
                component: ElasticComputeCloudResource,
                meta: {
                  title: '计算实例',
                  order: "5-3-1-1",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:elasticComputeCloudResource:add',
                    'resourceConfigurationManagement:aws:elasticComputeCloudResource:update',
                    'resourceConfigurationManagement:aws:elasticComputeCloudResource:page',
                    'resourceConfigurationManagement:aws:elasticComputeCloudResource:export',
                    'resourceConfigurationManagement:aws:elasticComputeCloudResource:exportAWSInstanceMetric',
                    'resourceConfigurationManagement:aws:elasticComputeCloudResource:exportAWSInstancesAndSecurityGroup',
                  ]

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/dedicatedHostingResource',
                component: DedicatedHostingResource,
                meta: {
                  title: '专用主机',
                  order: "5-3-1-24",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:dedicatedHostingResource:update',
                    'resourceConfigurationManagement:aws:dedicatedHostingResource:page',
                    'resourceConfigurationManagement:aws:dedicatedHostingResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/relationalDatabaseServiceResource',
                component: RelationalDatabaseServiceResource,
                meta: {
                  title: '数据库',
                  order: "5-3-1-2",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:update',
                    'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:page',
                    'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:export',
                    'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:subnet_detail',
                    'resourceConfigurationManagement:aws:subnetResource:export',
                    'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:exportAWSDatabaseMetric']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/virtualPrivateCloudResource',
                component: VirtualPrivateCloudResource,
                meta: {
                  title: '虚拟网络',
                  order: "5-3-1-3",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:virtualPrivateCloudResource:update',
                    'resourceConfigurationManagement:aws:virtualPrivateCloudResource:search', 'resourceConfigurationManagement:aws:virtualPrivateCloudResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/elasticBlockStoreResource',
                component: ElasticBlockStoreResource,
                meta: {
                  title: '弹性块存储',
                  order: "5-3-1-4",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:elasticBlockStoreResource:update',
                    'resourceConfigurationManagement:aws:elasticBlockStoreResource:page',
                    'resourceConfigurationManagement:aws:elasticBlockStoreResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/elasticLoadBalancingResource',
                component: ElasticLoadBalancingResource,
                meta: {
                  title: '弹性负载均衡',
                  order: "5-3-1-5",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:elasticLoadBalancingResource:update',
                    'resourceConfigurationManagement:aws:elasticLoadBalancingResource:search',
                    'resourceConfigurationManagement:aws:elasticLoadBalancingResource:export', 'resourceConfigurationManagement:aws:elasticLoadBalancingResource:search']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/simpleStorageServiceResource',
                component: SimpleStorageServiceResource,
                meta: {
                  title: '存储桶',
                  order: "5-3-1-6",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:simpleStorageServiceResource:update',
                    'resourceConfigurationManagement:aws:simpleStorageServiceResource:page',
                    'resourceConfigurationManagement:aws:simpleStorageServiceResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/redshiftResource',
                component: RedshiftResource,
                meta: {
                  title: 'redshift',
                  order: "5-3-1-8",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:redshiftResource:update',
                    'resourceConfigurationManagement:aws:redshiftResource:page',
                    'resourceConfigurationManagement:aws:redshiftResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/elastiCacheResourceInfo',
                component: ElastiCacheResourceInfo,
                meta: {
                  title: '弹性缓存',
                  order: "5-3-1-9",
                  requireAuth: true
                },
                children: [
                  {
                    path: '/resourceConfigurEationManagement/aws/elastiCacheResource/memcached',
                    component: ElastiCacheResourceMemcached,
                    meta: {
                      title: 'Memcached',
                      order: "5-3-1-9-1",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceMemcached:update',
                        'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceMemcached:page',
                        'resourceConfigurationManagement:aws:elastiCacheResource:memcached:export']

                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/elastiCacheResource/redis',
                    component: ElastiCacheResourceRedis,
                    meta: {
                      title: 'Redis',
                      order: "5-3-1-9-2",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceRedis:update',
                        'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceRedis:page',
                        'resourceConfigurationManagement:aws:elastiCacheResource:redis:export']
                    }
                  }
                ]
              },
              {
                path: '/resourceConfigurationManagement/aws/reservedInstanceResource',
                component: Tenth,
                meta: {
                  title: '预留实例',
                  order: "5-3-1-10",
                  requireAuth: true
                },
                children: [
                  {
                    path: '/resourceConfigurationManagement/aws/reservedInstanceResource/ec2',
                    component: ElasticComputeCloudReservedInstance,
                    meta: {
                      title: 'EC2',
                      order: "5-3-1-10-1",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:reservedInstanceResource:ec2:config',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:ec2:page	',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:ec2:export']

                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/reservedInstanceResource/rds',
                    component: RelationalDatabaseServiceReservedInstance,
                    meta: {
                      title: 'RDS',
                      order: "5-3-1-10-2",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:reservedInstanceResource:rds:config',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:rds:page',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:rds:export']

                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/reservedInstanceResource/elasticCache',
                    component: ElasticacheReservedInstance,
                    meta: {
                      title: 'ElasticCache',
                      order: "5-3-1-10-3",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:reservedInstanceResource:elasticCache:config',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:elasticCache:search', 'resourceConfigurationManagement:aws:reservedInstanceResource:elasticCache:export']

                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/reservedInstanceResource/redshift',
                    component: RedshiftReservedInstance,
                    meta: {
                      title: 'Redshift',
                      order: "5-3-1-10-4",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:reservedInstanceResource:redshift:page',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:redshift:config',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:redshift:export']

                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/reservedInstanceResource/elasticsearch',
                    component: ElasticsearchReservedInstance,
                    meta: {
                      title: 'Elasticsearch',
                      order: "5-3-1-10-5",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:reservedInstanceResource:elasticsearch:config',
                        'resourceConfigurationManagement:aws:reservedInstanceResource:elasticsearch:search', 'resourceConfigurationManagement:aws:reservedInstanceResource:elasticsearch:export']

                    }
                  }]
              },

              {
                path: '/resourceConfigurationManagement/aws/iamConfig',
                component: Eleventh,
                meta: {
                  title: '身份和访问管理',
                  order: "5-3-1-17",
                  requireAuth: true
                },
                children: [
                  {
                    path: '/resourceConfigurationManagement/aws/iamConfig/groupResource',
                    component: GroupResource,
                    meta: {
                      title: '组',
                      order: "5-3-1-17-1",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:iamConfig:groupResource:update',
                        'resourceConfigurationManagement:aws:iamConfig:groupResource:page',
                        'resourceConfigurationManagement:aws:iamConfig:groupResource:export']
                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/iamConfig/policyResource',
                    component: PolicyResource,
                    meta: {
                      title: '策略',
                      order: "5-3-1-17-2",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:iamConfig:policyResource:page',
                        'resourceConfigurationManagement:aws:iamConfig:policyResource:update',
                        'resourceConfigurationManagement:aws:iamConfig:policyResource:export']
                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/iamConfig/identityAndAccessManagementResource',
                    component: IdentityAndAccessManagementResource,
                    meta: {
                      title: '用户',
                      order: "5-3-1-17-3",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:identityAndAccessManagementResource:page',
                        'resourceConfigurationManagement:aws:identityAndAccessManagementResource:update',
                        'resourceConfigurationManagement:aws:identityAndAccessManagementResource:search', 'resourceConfigurationManagement:aws:identityAndAccessManagementResource:export']

                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/iamConfig/akskResource',
                    component: AkskResource,
                    meta: {
                      title: 'AKSK',
                      order: "5-3-1-17-4",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:iamConfig:akskResource:update',
                        'resourceConfigurationManagement:aws:iamConfig:akskResource:page',
                        'resourceConfigurationManagement:aws:iamConfig:akskResource:export']
                    }
                  }
                ]
              },
              {
                path: '/resourceConfigurationManagement/aws/elasticResource',
                component: ElasticResource,
                meta: {
                  title: '弹性IP',
                  order: "5-3-1-11",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:elasticResource:update',
                    'resourceConfigurationManagement:aws:elasticResource:page',
                    'resourceConfigurationManagement:aws:elasticResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/routeResource',
                component: RouteResource,
                meta: {
                  title: '路由表',
                  order: "5-3-1-12",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:routeResource:update',
                    'resourceConfigurationManagement:aws:routeResource:page',
                    'resourceConfigurationManagement:aws:routeResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/gatewayResource',
                component: GatewayResource,
                meta: {
                  title: '网关',
                  order: "5-3-1-13",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:gatewayResource:update',
                    'resourceConfigurationManagement:aws:gatewayResource:page',
                    'resourceConfigurationManagement:aws:gatewayResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/subnetResource',
                component: SubnetResource,
                meta: {
                  title: '子网',
                  order: "5-3-1-14",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:subnetResource:update',
                    'resourceConfigurationManagement:aws:subnetResource:page',
                    'resourceConfigurationManagement:aws:subnetResource:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/securityGroup',
                component: SecurityGroup,
                meta: {
                  title: '安全组',
                  order: "5-3-1-15",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:securityGroup:update',
                    'resourceConfigurationManagement:aws:securityGroup:page',
                    'resourceConfigurationManagement:aws:securityGroup:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/aws/event',
                component: Event,
                meta: {
                  title: '资源变更记录',
                  order: "5-3-1-16",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:event:page',
                    'resourceConfigurationManagement:aws:event:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/elasticsearchResource',
                component: ElasticsearchResource,
                meta: {
                  title: 'Elasticsearch',
                  order: "5-3-1-7",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:elasticsearch:update',
                    'resourceConfigurationManagement:aws:elasticsearch:page',
                    'resourceConfigurationManagement:aws:elasticsearch:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/elasticBlockStoreSnapshotResource',
                component: ElasticBlockStoreSnapshotResource,
                meta: {
                  title: 'ebs快照',
                  order: "5-3-1-18",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:elasticBlockStoreSnapshotResource:update',
                    'resourceConfigurationManagement:aws:elasticBlockStoreSnapshotResource:page',
                    'resourceConfigurationManagement:aws:elasticBlockStoreSnapshotResource:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/natGatewayResource',
                component: NatGatewayResource,
                meta: {
                  title: 'NAT网关',
                  order: "5-3-1-19",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:natGatewayResource:update',
                    'resourceConfigurationManagement:aws:natGatewayResource:page',
                    'resourceConfigurationManagement:aws:natGatewayResource:export']
                }
              },

              {
                path: '/resourceConfigurationManagement/aws/eks',
                component: EKS,
                meta: {
                  title: 'EKS',
                  order: "5-3-1-20",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:eks:update',
                    'resourceConfigurationManagement:aws:eks:page',
                    'resourceConfigurationManagement:aws:eks:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/emr',
                component: EMR,
                meta: {
                  title: 'EMR',
                  order: "5-3-1-21",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:emr:update',
                    'resourceConfigurationManagement:aws:emr:page',
                    'resourceConfigurationManagement:aws:emr:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/tgw',
                component: TGW,
                meta: {
                  title: 'TGW',
                  order: "5-3-1-22",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:aws:tgw:update',
                    'resourceConfigurationManagement:aws:tgw:page',
                    'resourceConfigurationManagement:aws:tgw:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/BackupInfo',
                component: BackupInfo,
                meta: {
                  title: 'Backup',
                  order: "5-3-1-23",
                  requireAuth: true
                },
                children: [
                  {
                    path: '/resourceConfigurEationManagement/aws/backup/repository',
                    component: BackupRepository,
                    meta: {
                      title: '备份保管库',
                      order: "5-3-1-23-1",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:backup:repository:update',
                        'resourceConfigurationManagement:aws:backup:repository:page',
                        'resourceConfigurationManagement:aws:backup:repository:export', 'resourceConfigurationManagement:aws:backup:repository:backupVaultName']
                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/backup/repository/backupVaultName',
                    component: BackupVaultName,
                    meta: {
                      title: '备份保管库',
                      order: "5-3-1-23-1",
                      requireAuth: true
                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/backup/plan',
                    component: BackupPlan,
                    meta: {
                      title: '备份计划',
                      order: "5-3-1-23-2",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:backup:plan:update',
                        'resourceConfigurationManagement:aws:backup:plan:page',
                        'resourceConfigurationManagement:aws:backup:plan:export', 'resourceConfigurationManagement:aws:backup:plan:backupPlanName']
                    }
                  },

                  {
                    path: '/resourceConfigurationManagement/aws/backup/plan/backupPlanName',
                    component: BackupPlanName,
                    meta: {
                      title: '备份计划',
                      order: "5-3-1-23-2",
                      requireAuth: true
                    }
                  },
                ]
              },
              {
                path: '/resourceConfigurationManagement/aws/DocDBManage',
                component: DocDBManage,
                meta: {
                  title: 'DocDBManage',
                  order: '5-3-1-24',
                  requireAuth: true,
                  btnPermissions: ['resourceConfigurationManagement:aws:DocDBManage:page',
                    'resourceConfigurationManagement:aws:DocDBManage:update',
                    'resourceConfigurationManagement:aws:DocDBManage:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/DynamoDB',
                component: DynamoDB,
                meta: {
                  title: 'DynamoDB',
                  order: '5-3-1-25',
                  requireAuth: true,
                  btnPermissions: ['resourceConfigurationManagement:aws:DynamoDB:page',
                    'resourceConfigurationManagement:aws:DynamoDB:update',
                    'resourceConfigurationManagement:aws:DynamoDB:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/ecr',
                component: ECR,
                meta: {
                  title: 'ecr',
                  order: '5-3-1-26',
                  requireAuth: true,
                  btnPermissions: ['resourceConfigurationManagement:aws:ecr:page',
                    'resourceConfigurationManagement:aws:ecr:update',
                    'resourceConfigurationManagement:aws:ecr:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/ecs',
                component: ECS,
                meta: {
                  title: 'ecs',
                  order: '5-3-1-27',
                  requireAuth: true,
                  btnPermissions: ['resourceConfigurationManagement:aws:ecs:page',
                    'resourceConfigurationManagement:aws:ecs:update',
                    'resourceConfigurationManagement:aws:ecs:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/ecs/clusterDescription',
                component: ClusterDescription,
                meta: {
                  title: '集群描述',
                  order: "5-3-1-27",
                  requireAuth: true
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/kms',
                component: KMS,
                meta: {
                  title: 'kms',
                  order: '5-3-1-28',
                  requireAuth: true,
                  btnPermissions: ['resourceConfigurationManagement:aws:kms:page',
                    'resourceConfigurationManagement:aws:kms:update',
                    'resourceConfigurationManagement:aws:kms:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/aws/dms',
                component: DMS,
                meta: {
                  title: 'dms',
                  order: '5-3-1-29',
                  requireAuth: true
                },
                children: [
                  {
                    path: '/resourceConfigurationManagement/aws/dms/serverlessReplications',
                    component: ServerlessReplications,
                    meta: {
                      title: '无服务器复制',
                      order: "5-3-1-29-1",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:dms:serverless:update',
                        'resourceConfigurationManagement:aws:dms:serverless:page',
                        'resourceConfigurationManagement:aws:dms:serverless:export']
                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/aws/dms/replicationInstances',
                    component: ReplicationInstances,
                    meta: {
                      title: '复制实例',
                      order: "5-3-1-29-2",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:aws:dms:instance:update',
                        'resourceConfigurationManagement:aws:dms:instance:page',
                        'resourceConfigurationManagement:aws:dms:instance:export']
                    }
                  }
                ]
              }
            ]
          },
          {
            path: '/resourceConfigurationManagement/azure',
            component: Seventh,
            meta: {
              title: 'Azure',
              order: "5-3-2",
              requireAuth: true
            },
            children: [
              {
                path: '/resourceConfigurationManagement/azure/elasticComputeCloudResourceAzure',
                component: ElasticComputeCloudResourceAzure,
                meta: {
                  title: '虚拟机',
                  order: "5-3-2-1",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:elasticComputeCloudResourceAzure:update',
                    'resourceConfigurationManagement:azure:elasticComputeCloudResourceAzure:page',
                    'resourceConfigurationManagement:azure:elasticComputeCloudResourceAzure:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/azure/relationalDatabaseServiceResourceAzure',
                component: RelationalDatabaseServiceResourceAzure,
                meta: {
                  title: '数据库',
                  order: "5-3-2-2",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:relationalDatabaseServiceResourceAzure:update',
                    'resourceConfigurationManagement:azure:relationalDatabaseServiceResourceAzure:page',
                    'resourceConfigurationManagement:azure:relationalDatabaseServiceResourceAzure:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/azure/virtualPrivateCloudResourceAzure',
                component: VirtualPrivateCloudResourceAzure,
                meta: {
                  title: '虚拟网络',
                  order: "5-3-2-3",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:virtualPrivateCloudResourceAzure:update',
                    'resourceConfigurationManagement:azure:virtualPrivateCloudResourceAzure:export', 'resourceConfigurationManagement:azure:virtualPrivateCloudResourceAzure:page']

                }
              },
              {
                path: '/resourceConfigurationManagement/azure/elasticBlockStoreResourceAzure',
                component: ElasticBlockStoreResourceAzure,
                meta: {
                  title: '托管磁盘',
                  order: "5-3-2-4",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:elasticBlockStoreResourceAzure:update',
                    'resourceConfigurationManagement:azure:elasticBlockStoreResourceAzure:page',
                    'resourceConfigurationManagement:azure:elasticBlockStoreResourceAzure:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/azure/simpleStorageServiceResourceAzure',
                component: SimpleStorageServiceResourceAzure,
                meta: {
                  title: '存储账户',
                  order: "5-3-2-5",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:simpleStorageServiceResourceAzure:update',
                    'resourceConfigurationManagement:azure:simpleStorageServiceResourceAzure:page',
                    'resourceConfigurationManagement:azure:simpleStorageServiceResourceAzure:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/azure/appServiceResourceAzure',
                component: AppServiceResourceAzure,
                meta: {
                  title: '应用程序服务',
                  order: "5-3-2-6",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:appServiceResourceAzure:update',
                    'resourceConfigurationManagement:azure:appServiceResourceAzure:page',
                    'resourceConfigurationManagement:azure:appServiceResourceAzure:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/azure/loadBalance',
                component: LoadBalancingResourceAzure,
                meta: {
                  title: '负载均衡',
                  order: "5-3-2-7",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:azure:loadBalance:update',
                    'resourceConfigurationManagement:azure:loadBalance:page',
                    'resourceConfigurationManagement:azure:loadBalance:export']
                }
              }
            ]
          },
          {
            path: '/resourceConfigurationManagement/ali',
            component: Twelfth,
            meta: {
              title: 'Ali',
              order: "5-3-3",
              requireAuth: true
            },
            children: [
              {
                path: '/resourceConfigurationManagement/ali/elasticComputeCloudResourceAli',
                component: ElasticComputeCloudResourceAli,
                meta: {
                  title: '计算实例',
                  order: "5-3-3-1",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:elasticComputeCloudResourceAli:update',
                    'resourceConfigurationManagement:ali:elasticComputeCloudResourceAli:page',
                    'resourceConfigurationManagement:ali:elasticComputeCloudResourceAli:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/relationalDatabaseServiceResourceAli',
                component: RelationalDatabaseServiceResourceAli,
                meta: {
                  title: '数据库',
                  order: "5-3-3-2",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:relationalDatabaseServiceResourceAli:update',
                    'resourceConfigurationManagement:ali:relationalDatabaseServiceResourceAli:page',
                    'resourceConfigurationManagement:ali:relationalDatabaseServiceResourceAli:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/elasticBlockStoreResourceAli',
                component: ElasticBlockStoreResourceAli,
                meta: {
                  title: '弹性块存储',
                  order: "5-3-3-3",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:elasticBlockStoreResourceAli:update',
                    'resourceConfigurationManagement:ali:elasticBlockStoreResourceAli:page',
                    'resourceConfigurationManagement:ali:elasticBlockStoreResourceAli:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/elasticResourceIp',
                component: ElasticResourceIp,
                meta: {
                  title: '弹性公网IP',
                  order: "5-3-3-4",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:elasticResourceIp:update',
                    'resourceConfigurationManagement:ali:elasticResourceIp:page',
                    'resourceConfigurationManagement:ali:elasticResourceIp:export']

                }
              },
              {
                path: '/resourceConfigurationManagement/ali/elasticLoadBalancingResourceAli',
                component: ElasticLoadBalancingResourceAli,
                meta: {
                  title: '负载均衡',
                  order: "5-3-3-5",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:elasticLoadBalancingResourceAli:update',
                    'resourceConfigurationManagement:ali:elasticLoadBalancingResourceAli:page',
                    'resourceConfigurationManagement:ali:elasticLoadBalancingResourceAli:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/redis',
                component: RedisAli,
                meta: {
                  title: 'Redis',
                  order: "5-3-3-6",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:redis:update',
                    'resourceConfigurationManagement:ali:redis:page',
                    'resourceConfigurationManagement:ali:redis:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/ack',
                component: AckAli,
                meta: {
                  title: 'Ack',
                  order: "5-3-3-15",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:Ack:export',
                    'resourceConfigurationManagement:ali:Ack:update',
                    'resourceConfigurationManagement:ali:Ack:page']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/vpc',
                component: VPC,
                meta: {
                  title: '虚拟网络',
                  order: "5-3-3-7",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:vpc:update',
                    'resourceConfigurationManagement:ali:vpc:page',
                    'resourceConfigurationManagement:ali:vpc:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/oss',
                component: OSS,
                meta: {
                  title: '存储桶',
                  order: "5-3-3-8",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:oss:update',
                    'resourceConfigurationManagement:ali:oss:page',
                    'resourceConfigurationManagement:ali:oss:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/natGateway',
                component: NatGateway,
                meta: {
                  title: 'NAT网关',
                  order: "5-3-3-9",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:natGateway:update',
                    'resourceConfigurationManagement:ali:natGateway:page',
                    'resourceConfigurationManagement:ali:natGateway:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/sls',
                component: SLS,
                meta: {
                  title: 'SLS',
                  order: "5-3-3-10",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:sls:update',
                    'resourceConfigurationManagement:ali:sls:page',
                    'resourceConfigurationManagement:ali:sls:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/autoScaling',
                component: AutoScaling,
                meta: {
                  title: '弹性伸缩',
                  order: "5-3-3-11",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:autoScaling:update',
                    'resourceConfigurationManagement:ali:autoScaling:page',
                    'resourceConfigurationManagement:ali:autoScaling:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/clickHouse',
                component: ClickHouse,
                meta: {
                  title: 'ClickHouse',
                  order: "5-3-3-14",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:clickHouse:update',
                    'resourceConfigurationManagement:ali:clickHouse:page',
                    'resourceConfigurationManagement:ali:clickHouse:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/cen',
                component: CENAli,
                meta: {
                  title: '云企业网CEN',
                  order: "5-3-3-12",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:cen:update',
                    'resourceConfigurationManagement:ali:cen:page',
                    'resourceConfigurationManagement:ali:cen:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/kafka',
                component: Kafka,
                meta: {
                  title: '消息队列Kafka',
                  order: "5-3-3-13",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:kafka:update',
                    'resourceConfigurationManagement:ali:kafka:page',
                    'resourceConfigurationManagement:ali:kafka:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/reservedInstances',
                component: ReservedInstances,
                meta: {
                  title: 'ECS预留实例劵',
                  order: "5-3-3-17",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:reservedInstances:update',
                    'resourceConfigurationManagement:ali:reservedInstances:page',
                    'resourceConfigurationManagement:ali:reservedInstances:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/ali/waf',
                component: Waf,
                meta: {
                  title: 'web应用防火墙',
                  order: "5-3-3-16",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:ali:waf:update',
                    'resourceConfigurationManagement:ali:waf:page',
                    'resourceConfigurationManagement:ali:waf:export']
                }
              },

            ]
          },
          {
            path: '/resourceConfigurationManagement/gcp',
            component: Fourteenth,
            meta: {
              title: 'Gcp',
              order: "5-3-4",
              requireAuth: true
            },
            children: [
              {
                path: '/resourceConfigurationManagement/gcp/elasticComputeCloudResourceGcp',
                component: ElasticComputeCloudResourceGcp,
                meta: {
                  title: '计算实例',
                  order: "5-3-4-1",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:elasticComputeCloudResourceGcp:update',
                    'resourceConfigurationManagement:gcp:elasticComputeCloudResourceGcp:page',
                    'resourceConfigurationManagement:gcp:elasticComputeCloudResourceGcp:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/relationalDatabaseServiceResourceGcp',
                component: RelationalDatabaseServiceResourceGcp,
                meta: {
                  title: '数据库',
                  order: "5-3-4-2",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:relationalDatabaseServiceResourceGcp:update',
                    'resourceConfigurationManagement:gcp:relationalDatabaseServiceResourceGcp:page',
                    'resourceConfigurationManagement:gcp:relationalDatabaseServiceResourceGcp:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/elasticBlockStoreResourceGcp',
                component: ElasticBlockStoreResourceGcp,
                meta: {
                  title: '弹性块存储',
                  order: "5-3-4-3",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:elasticBlockStoreResourceGcp:update',
                    'resourceConfigurationManagement:gcp:elasticBlockStoreResourceGcp:page',
                    'resourceConfigurationManagement:gcp:elasticBlockStoreResourceGcp:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/elasticLoadBalancingResourceGcp',
                component: ElasticLoadBalancingResourceGcp,
                meta: {
                  title: '负载均衡',
                  order: "5-3-4-4",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:elasticLoadBalancingResourceGcp:update',
                    'resourceConfigurationManagement:gcp:elasticLoadBalancingResourceGcp:page',
                    'resourceConfigurationManagement:gcp:elasticLoadBalancingResourceGcp:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/cloudStorageGcp',
                component: CloudStorageGcp,
                meta: {
                  title: 'CloudStorage',
                  order: "5-3-4-5",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:cloudStorageGcp:update',
                    'resourceConfigurationManagement:gcp:cloudStorageGcp:page',
                    'resourceConfigurationManagement:gcp:cloudStorageGcp:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/bigQuery',
                component: BigQuery,
                meta: {
                  title: 'BigQuery',
                  order: "5-3-4-6",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:bigQuery:update',
                    'resourceConfigurationManagement:gcp:bigQuery:page',
                    'resourceConfigurationManagement:gcp:bigQuery:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/redisGcp',
                component: RedisGcp,
                meta: {
                  title: 'RedisGcp',
                  order: "5-3-4-7",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:redisGcp:update',
                    'resourceConfigurationManagement:gcp:redisGcp:page',
                    'resourceConfigurationManagement:gcp:redisGcp:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/filestore',
                component: Filestore,
                meta: {
                  title: 'Filestore',
                  order: "5-3-4-8",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:filestore:update',
                    'resourceConfigurationManagement:gcp:filestore:page',
                    'resourceConfigurationManagement:gcp:filestore:export']
                }
              },
              {
                path: '/resourceConfigurationManagement/gcp/kubernetes',
                component: Kubernetes,
                meta: {
                  title: 'Kubernetes',
                  order: "5-3-4-9",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:gcp:kubernetes:update',
                    'resourceConfigurationManagement:gcp:kubernetes:page',
                    'resourceConfigurationManagement:gcp:kubernetes:export']
                }
              },
              {
                path: '/gcp',
                component: GcpLogging,
                meta: {
                  title: 'GcpLogging',
                  order: "5-3-4-10",
                  requireAuth: true,
                },
                children: [
                  {
                    path: '/resourceConfigurationManagement/gcp/log/logrouting',
                    component: Logrouting,
                    meta: {
                      title: '日志路由',
                      order: "5-3-4-10-1",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:gcp:log:logrouting:update',
                        'resourceConfigurationManagement:gcp:log:logrouting:page',
                        'resourceConfigurationManagement:gcp:log:logrouting:export']
                    }
                  },
                  {
                    path: '/resourceConfigurationManagement/gcp/log/loggingstored',
                    component: Loggingstored,
                    meta: {
                      title: '日志存储',
                      order: "5-3-4-10-2",
                      requireAuth: true,
                      btnPermissions: [
                        'resourceConfigurationManagement:gcp:log:loggingstored:update',
                        'resourceConfigurationManagement:gcp:log:loggingstored:page',
                        'resourceConfigurationManagement:gcp:log:loggingstored:export']
                    }
                  }
                ]
              },

            ]
          },
          {
            path: '/resourceConfigurationManagement/hwc',
            component: Fifteenth,
            meta: {
              title: 'HUAWEI Cloud',
              order: "5-3-5",
              requireAuth: true
            },
            children: [
              {
                path: '/resourceConfigurationManagement/hwc/elasticComputeCloudResourceHwc',
                component: ElasticComputeCloudResourceHwc,
                meta: {
                  title: 'ECS',
                  order: "5-3-5-1",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:hwc:elasticComputeCloudResourceHwc:update',
                    'resourceConfigurationManagement:hwc:elasticComputeCloudResourceHwc:page',
                    'resourceConfigurationManagement:hwc:elasticComputeCloudResourceHwc:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/hwc/relationalDatabaseServiceResourceHwc',
                component: RelationalDatabaseServiceResourceHwc,
                meta: {
                  title: 'RDS',
                  order: "5-3-5-2",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:hwc:relationalDatabaseServiceResourceHwc:update',
                    'resourceConfigurationManagement:hwc:relationalDatabaseServiceResourceHwc:page',
                    'resourceConfigurationManagement:hwc:relationalDatabaseServiceResourceHwc:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/hwc/elasticCloudDiskHwc',
                component: ElasticCloudDiskHwc,
                meta: {
                  title: 'EVS',
                  order: "5-3-5-3",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:hwc:relationalVolumeServiceResourceHwc:update',
                    'resourceConfigurationManagement:hwc:relationalVolumeServiceResourceHwc:page',
                    'resourceConfigurationManagement:hwc:relationalVolumeServiceResourceHwc:export'
                  ]
                }
              },
              {
                path: '/resourceConfigurationManagement/hwc/objectStorageHwc',
                component: ObjectStorageHwc,
                meta: {
                  title: 'OBS',
                  order: "5-3-5-4",
                  requireAuth: true,
                  btnPermissions: [
                    'resourceConfigurationManagement:hwc:relationalBucketServiceResourceHwc:update',
                    'resourceConfigurationManagement:hwc:relationalBucketServiceResourceHwc:page',
                    'resourceConfigurationManagement:hwc:relationalBucketServiceResourceHwc:export'
                  ]
                }
              }
            ]
          }
        ]
      },
      {
        path: '/operationKpiConfigurationManagement',
        component: Eighth,
        meta: {
          title: '运维配置管理',
          order: "5-5",
          requireAuth: true
        },
        children: [
          {
            path: '/operationKpiConfigurationManagement/operationDutyManagement',
            component: OperationDutyManagement,
            meta: {
              title: '值班管理',
              order: "5-5-1",
              requireAuth: true,
              btnPermissions: [
                'operationKpiConfigurationManagement:operationDutyManagement:delete',
                'operationKpiConfigurationManagement:operationDutyManagement:export', 'operationKpiConfigurationManagement:operationDutyManagement:add_duty']

            }
          },
          {
            path: '/operationKpiConfigurationManagement/overtimeManagement',
            component: OvertimeManagement,
            meta: {
              title: '额外贡献管理',
              order: "5-5-2",
              requireAuth: true,
              btnPermissions: [
                'operationKpiConfigurationManagement:overtimeManagement:delete',
                'operationKpiConfigurationManagement:overtimeManagement:download',
                'operationKpiConfigurationManagement:overtimeManagement:export', 'operationKpiConfigurationManagement:overtimeManagement:add_overtime_duty', 'operationKpiConfigurationManagement:overtimeManagement:add_attachment', 'operationKpiConfigurationManagement:overtimeManagement:delete']

            }
          },
          {
            path: '/operationKpiConfigurationManagement/operationReport',
            component: OperationReport,
            meta: {
              title: '自动化运维报告',
              order: "5-5-3",
              requireAuth: true,
              btnPermissions: [
                'operationKpiConfigurationManagement:operationReport:add_report', 'operationKpiConfigurationManagement:operationReport:report_config', 'operationKpiConfigurationManagement:reportConfiguration:add_RI_reccmd_contrast', 'operationKpiConfigurationManagement:reportConfiguration:delete_RI_reccmd_contrast', 'operationKpiConfigurationManagement:reportConfiguration:add_RI_instance', 'operationKpiConfigurationManagement:reportConfiguration:delete_RI_instance', 'operationKpiConfigurationManagement:reportConfiguration:update_billing_stats', 'operationKpiConfigurationManagement:reportConfiguration:add_EC2', 'operationKpiConfigurationManagement:reportConfiguration:delete_EC2', 'operationKpiConfigurationManagement:reportConfiguration:update_EC2', 'operationKpiConfigurationManagement:reportConfiguration:add_RDS', 'operationKpiConfigurationManagement:reportConfiguration:delete_RDS', 'operationKpiConfigurationManagement:reportConfiguration:update_RDS', 'operationKpiConfigurationManagement:reportConfiguration:add_contrast_report', 'operationKpiConfigurationManagement:reportConfiguration:delete_contrast_report', 'operationKpiConfigurationManagement:reportConfiguration:add_maintain', 'operationKpiConfigurationManagement:reportConfiguration:add_modified_maintain', 'operationKpiConfigurationManagement:reportConfiguration:delete_maintain', 'operationKpiConfigurationManagement:reportConfiguration:add_pending_maintain', 'operationKpiConfigurationManagement:reportConfiguration:delete_pending_maintain', 'operationKpiConfigurationManagement:reportConfiguration:add_important_event', 'operationKpiConfigurationManagement:reportConfiguration:important_detail', 'operationKpiConfigurationManagement:reportConfiguration:delete_important', 'operationKpiConfigurationManagement:operationReport:edit', 'operationKpiConfigurationManagement:operationReport:overview', 'operationKpiConfigurationManagement:operationReport:delete']

            }
          },
          {
            path: '/operationKpiConfigurationManagement/reportConfiguration',
            component: ReportConfiguration,
            meta: {
              title: '报告配置',
              order: "5-5-3",
              requireAuth: true
            }
          },
        ]
      },
      {
        path: '/alarmContact',
        component: AlarmContact,
        type: 'ios-people-outline',
        meta: {
          title: '报警联系人配置',
          order: "5-2",
          requireAuth: true,
          btnPermissions: [
            'alarm_contact:AlarmContact:log',
            'alarm_contact:AlarmContact:group_log',
            'alarm_contact:AlarmContact:robot_log',
            'alarmContact:group:config',
            'alarm_contact:AlarmContact:create',
            'alarm_contact:AlarmContact:replaceContact',
            'alarm_contact:AlarmContact:deleteContact',
            'alarm_contact:AlarmContact:update',
            'alarm_contact:AlarmContactGroup:create','alarm_contact:AlarmContactGroup:batchCreate','alarm_contact:AlarmContactGroup:deleteByContactIdAndContactGroupId',
            'alarm_contact:AlarmContactGroup:delete','alarm_contact:AlarmContactGroup:update','alarm_contact:AlarmContactWechatRobot:createOrUpdate',
            'alarm_contact:AlarmContactWechatRobot:delete',
            'alarmContact:add_contact', 'alarmContact:delete', 'alarmContact:edit']
        }
      },
      {
        path: '/alarmContact/contactConfiguration',
        component: ContactConfiguration,
        type: 'ios-people-outline',
        meta: {
          title: '报警联系人详情',
          order: "5-2",
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/instanceLists',
    type: 'ios-photos-outline',
    component: Main,
    meta: {
      title: '实例列表',
      order: "6",
      requireAuth: true
    },
    children: [
      {
        path: '/instanceLists/instanceList',
        component: InstanceList,
        meta: {
          title: '太古实例列表',
          order: "6-1",
          requireAuth: true,
          btnPermissions: ['instanceLists:instanceList:export']

        }
      }
    ]
  }
]


export default new Router({
  routes: constantRouterMap
})

// 解决路由跳转相同的地址报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  try {
    return originalPush.call(this, location).catch(err => err);
  } catch (error) {
    console.error(error);
  }
};




// WEBPACK FOOTER //
// ./src/router/index.js